(function(){
"use strict";
/* ============================================================================
   MIDNIGHT CREW · CUSTOMER INTELLIGENCE
   Mesma linguagem visual e mecânica da página de produto (mc-produto.js):
   skeleton fantasma, ícones SVG inline, scramble dos números, barras que
   crescem no pós-render, gauges divergentes e FAB + drawer de insights.
   Aqui o drawer é seccionado, porque o cruzamento de dados é muito maior.
   ========================================================================== */
/* Implantação com os recursos customer_analytics / customer_base / customer_extra.
   As outras implantações do projeto estão presas em versões antigas do script e
   respondem "recurso desconhecido" — se um dia isso voltar a acontecer, é porque
   o deploy foi feito noutra implantação, não porque o código sumiu. */
var MC_API   = "https://script.google.com/macros/s/AKfycbx9aaPhx7x-nEVZqZ42EWcDYidUKODBrnrEmOIPCmMjTSdIw74-b7OHkHLBJg6reSi7/exec";
var MC_TOKEN = "mc_cc6f126b6aaf46bfa553068c22727813";
var PAGE_PEDIDO  = "/pages/pedido";
var PAGE_PRODUTO = "/pages/produto";

function call(p,ms){
  return new Promise(function(res,rej){
    var cb="mc_cb_"+Math.random().toString(36).slice(2),s=document.createElement("script");
    var to=setTimeout(function(){cl();rej(new Error("timeout"));},ms||25000);
    function cl(){clearTimeout(to);try{delete window[cb];}catch(e){}if(s.parentNode)s.parentNode.removeChild(s);}
    window[cb]=function(d){cl();res(d);};
    var qs=Object.keys(p).map(function(k){return encodeURIComponent(k)+"="+encodeURIComponent(p[k]);}).join("&");
    s.src=MC_API+"?key="+encodeURIComponent(MC_TOKEN)+"&callback="+cb+"&"+qs;
    s.onerror=function(){cl();rej(new Error("net"));};
    document.head.appendChild(s);
  });
}
var BRL =function(n){return (Number(n)||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});};
var PCT =function(n){return ((Number(n)||0)*100).toFixed(1)+"%";};
var PCT0=function(n){return Math.round((Number(n)||0)*100)+"%";};
var NUM =function(n){return (Number(n)||0).toLocaleString("pt-BR");};
var DATE=function(s){if(!s)return"—";var d=new Date(s);return isNaN(d)?"—":d.toLocaleDateString("pt-BR");};
var DIAS=function(n){n=Math.round(Number(n)||0);return n+(Math.abs(n)===1?" dia":" dias");};
var kBRL=function(n){n=Number(n)||0;if(n>=1000000)return"R$"+(n/1000000).toFixed(1).replace(".",",")+"M";if(n>=1000)return"R$"+(n/1000).toFixed(1).replace(".",",")+"k";return"R$"+Math.round(n);};
var esc =function(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){return({"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"})[c];});};
function cap(s){s=String(s||"");return s?s.charAt(0).toUpperCase()+s.slice(1):s;}
function nz(v){var n=Number(v);return isNaN(n)?0:n;}
function clamp(x,lo,hi){return Math.max(lo,Math.min(hi,x));}
function daysAgo(s){if(!s)return null;var d=new Date(s);if(isNaN(d))return null;return Math.round((Date.now()-d.getTime())/86400000);}
function multi(n,x){return (Number(x)||0)?(n/x):0;}

/* ---- ícones (line, 24×24) — tamanho SEMPRE via CSS ---- */
var ICO={
  money:'<line x1="12" y1="2" x2="12" y2="22"/><path d="M17 6H9.5a3 3 0 0 0 0 6h5a3 3 0 0 1 0 6H6"/>',
  grid:'<rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>',
  calendar:'<rect x="3" y="4" width="18" height="18" rx="1"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>',
  info:'<circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="11"/><line x1="12" y1="7.5" x2="12.01" y2="7.5"/>',
  chart:'<line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>',
  compare:'<path d="M12 3v18"/><path d="M6 8l-4 4 4 4"/><path d="M18 8l4 4-4 4"/>',
  bolt:'<polygon points="13 2 4 14 12 14 11 22 20 10 12 10 13 2"/>',
  list:'<line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>',
  box:'<path d="M21 16V8a2 2 0 0 0-1-1.7l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.7l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.3 7 12 12 20.7 7"/><line x1="12" y1="22" x2="12" y2="12"/>',
  star:'<polygon points="12 2 15 9 22 9.3 16.5 14 18.5 21 12 17 5.5 21 7.5 14 2 9.3 9 9"/>',
  check:'<polyline points="20 6 9 17 4 12"/>',
  alert:'<path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>',
  clock:'<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>',
  trophy:'<path d="M8 21h8"/><path d="M12 17v4"/><path d="M7 4h10v5a5 5 0 0 1-10 0z"/><path d="M17 5h3v2a3 3 0 0 1-3 3"/><path d="M7 5H4v2a3 3 0 0 0 3 3"/>',
  eye:'<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/><circle cx="12" cy="12" r="3"/>',
  filter:'<polygon points="22 3 2 3 10 12.5 10 19 14 21 14 12.5 22 3"/>',
  route:'<circle cx="6" cy="19" r="3"/><path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15"/><circle cx="18" cy="5" r="3"/>',
  cpu:'<rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><path d="M9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3"/>',
  bulb:'<path d="M9 18h6"/><path d="M10 22h4"/><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"/>',
  swap:'<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
  pin:'<path d="M12 21s-7-6.5-7-11a7 7 0 0 1 14 0c0 4.5-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/>',
  cart:'<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>',
  gauge:'<path d="M12 15l4-6"/><circle cx="12" cy="15" r="2"/><path d="M3.5 18a10 10 0 1 1 17 0"/>',
  /* novos, específicos de cliente */
  user:'<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
  cake:'<path d="M3 21h18"/><path d="M4 21v-6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6"/><path d="M8 13V9M12 13V9M16 13V9"/><path d="M8 6.5c0-1 1-1.5 1-2.5 0-.6-.4-1-1-1s-1 .4-1 1c0 1 1 1.5 1 2.5z"/><path d="M12 6.5c0-1 1-1.5 1-2.5 0-.6-.4-1-1-1s-1 .4-1 1c0 1 1 1.5 1 2.5z"/><path d="M16 6.5c0-1 1-1.5 1-2.5 0-.6-.4-1-1-1s-1 .4-1 1c0 1 1 1.5 1 2.5z"/>',
  ruler:'<path d="M3 9.5 9.5 3 21 14.5 14.5 21z"/><path d="M7.5 8.5 9 10"/><path d="M10 6l1.5 1.5"/><path d="M12.5 3.5 14 5"/><path d="M6 12l1.5 1.5"/>',
  palette:'<circle cx="12" cy="12" r="9.5"/><circle cx="8.5" cy="9" r="1.2"/><circle cx="15.5" cy="9" r="1.2"/><circle cx="8.5" cy="15" r="1.2"/><circle cx="15" cy="14.5" r="1.2"/>',
  truck:'<rect x="1" y="6" width="13" height="11"/><path d="M14 10h4l3 3v4h-7z"/><circle cx="5.5" cy="19" r="2"/><circle cx="17.5" cy="19" r="2"/>',
  repeat:'<polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>',
  target:'<circle cx="12" cy="12" r="9.5"/><circle cx="12" cy="12" r="5.5"/><circle cx="12" cy="12" r="1.6"/>',
  heart:'<path d="M20.8 5.6a5 5 0 0 0-7.1 0L12 7.3l-1.7-1.7a5 5 0 1 0-7.1 7.1l8.8 8.8 8.8-8.8a5 5 0 0 0 0-7.1z"/>',
  mail:'<rect x="2" y="4" width="20" height="16" rx="1"/><polyline points="2.5 5.5 12 13 21.5 5.5"/>',
  phone:'<path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/>',
  crown:'<path d="M3 18h18"/><path d="M3 7l4.5 4L12 4l4.5 7L21 7v8H3z"/>',
  tag:'<path d="M20.6 13.4 12 22l-9-9V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><line x1="7.5" y1="7.5" x2="7.51" y2="7.5"/>',
  down:'<polyline points="6 9 12 15 18 9"/>',
  arrow:'<line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>',
  flame:'<path d="M12 22c4 0 7-2.7 7-6.5 0-4.5-4-6.5-4-10.5-2.5 1-3.5 3-3.5 5C10 8 9 6.5 8 5.5c-1 1.5-3 3.5-3 10C5 19.3 8 22 12 22z"/>',
  shield:'<path d="M12 22s8-3.5 8-10V5l-8-3-8 3v7c0 6.5 8 10 8 10z"/>',
  layers:'<polygon points="12 2 2 7.5 12 13 22 7.5 12 2"/><polyline points="2 16.5 12 22 22 16.5"/><polyline points="2 12 12 17.5 22 12"/>'
};
function ic(name,cls){return '<svg class="cid-ic '+(cls||"")+'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">'+(ICO[name]||"")+'</svg>';}

function scoreRing(score,size,color){
  size=size||52;color=color||"#fff200";
  var r=(size-7)/2,C=2*Math.PI*r,fill=C*(clamp(Number(score)||0,0,100)/100);
  return '<svg width="'+size+'" height="'+size+'" viewBox="0 0 '+size+' '+size+'" style="transform:rotate(-90deg)">'
    +'<circle cx="'+size/2+'" cy="'+size/2+'" r="'+r+'" fill="none" stroke="#1e1e1e" stroke-width="5"/>'
    +'<circle cx="'+size/2+'" cy="'+size/2+'" r="'+r+'" fill="none" stroke="'+color+'" stroke-width="5"'
    +' stroke-dasharray="'+fill+' '+C+'" stroke-linecap="round"/></svg>';
}
/* embaralha os dígitos até assentar no valor */
function scrambleVal(el){
  var to=Number(el.getAttribute("data-to"))||0, fmt=el.getAttribute("data-fmt")||"num";
  var f=fmt==="brl"?BRL:fmt==="pct"?PCT:fmt==="pct0"?PCT0:fmt==="kbrl"?kBRL:fmt==="dias"?DIAS:NUM;
  var finalText=f(to), frames=16, frame=0, DIG="0123456789";
  if(el._t) cancelAnimationFrame(el._t);
  function tick(){
    var prog=frame/frames, out="";
    for(var i=0;i<finalText.length;i++){ var ch=finalText[i]; if(!/[0-9]/.test(ch)){out+=ch;continue;} out+= (prog>=(i+1)/finalText.length)? ch : DIG[Math.floor(Math.random()*10)]; }
    el.textContent=out;
    if(frame++>=frames){ el.textContent=finalText; el._t=null; return; }
    el._t=requestAnimationFrame(tick);
  }
  el._t=requestAnimationFrame(tick);
}

/* ==========================================================================
   ESTATÍSTICA — nenhuma afirmação sem n, sem intervalo e sem linha de base.
   Com 6 pedidos quase nada é significante; a página precisa dizer isso em vez
   de fabricar preferência a partir da ordem de um array.
   ========================================================================== */
var Z95=1.96;
/* Intervalo de Wilson: correto para n pequeno, ao contrário do normal simples,
   que com k=0 ou k=n devolve largura zero (falsa certeza). */
function wilson(k,n,z){
  z=z||Z95;
  if(!n) return {k:0,n:0,p:0,lo:0,hi:1,largura:1};
  var p=k/n, z2=z*z, den=1+z2/n;
  var centro=(p+z2/(2*n))/den;
  var margem=(z*Math.sqrt(p*(1-p)/n+z2/(4*n*n)))/den;
  var lo=Math.max(0,centro-margem), hi=Math.min(1,centro+margem);
  return {k:k,n:n,p:p,lo:lo,hi:hi,largura:hi-lo};
}
/* a proporção observada é distinguível da linha de base p0?
   Só afirmamos "acima"/"abaixo" quando o intervalo inteiro fica de um lado —
   é o que evita o erro tipo I (ver padrão onde só há ruído). */
function vsBase(k,n,p0){
  var w=wilson(k,n);
  var acima=w.lo>p0, abaixo=w.hi<p0;
  return {w:w,p0:p0,acima:acima,abaixo:abaixo,signif:(acima||abaixo),
    lift:(p0>0?(w.p-p0)/p0:0)};
}
/* rótulo de confiança: n pequeno e intervalo largo viram aviso explícito.
   Não some com o dado — mostra o dado E o quanto ele é frágil (erro tipo II). */
function confianca(w){
  if(!w||!w.n) return {k:"insuf",lbl:"sem dados",curto:"—"};
  if(w.n<3)          return {k:"insuf",lbl:"amostra insuficiente (n="+w.n+")",curto:"n="+w.n};
  if(w.largura>0.45) return {k:"baixa",lbl:"confiança baixa (intervalo largo)",curto:"±"+Math.round(w.largura*50)+"pp"};
  if(w.largura>0.25) return {k:"media",lbl:"confiança média",curto:"±"+Math.round(w.largura*50)+"pp"};
  return {k:"alta",lbl:"confiança alta",curto:"±"+Math.round(w.largura*50)+"pp"};
}
/* Vencedor de uma contagem, com empate honesto.
   Critério de "conclusivo": a fatia do 1º tem de ficar significativamente acima
   do que se esperaria por acaso entre as opções observadas (1/nº de opções).
   Empate ou diferença de 1 unidade em amostra pequena => inconclusivo. */
function preferencia(lista,total,minN){
  minN=minN||3;
  /* devolve sempre a mesma forma, inclusive vazia: quem consome (racional, selo,
     valorPref) não precisa saber se havia dados */
  if(!lista||!lista.length||!total)
    return {vazio:true,conclusivo:false,empate:false,margemUnica:false,
      top:{k:"—",n:0},seg:{k:"",n:0},w:wilson(0,0),opcoes:0,acaso:0,conf:confianca(null)};
  var top=lista[0], seg=lista[1]||{n:0,k:""};
  var w=wilson(top.n,total);
  var opcoes=lista.length;
  var acaso=1/Math.max(2,opcoes);
  var empate=(seg.n===top.n);
  var margemUnica=(!empate && total<12 && (top.n-seg.n)<=1);
  return {
    vazio:false, top:top, seg:seg, w:w, opcoes:opcoes, acaso:acaso,
    empate:empate, margemUnica:margemUnica,
    conclusivo: !empate && !margemUnica && total>=minN && w.lo>acaso,
    conf:confianca(w)
  };
}
/* texto padrão do intervalo, usado nos tooltips */
function ciTxt(w){ return PCT0(w.lo)+"–"+PCT0(w.hi); }
/* as linhas de racional que TODO tooltip de inferência carrega */
function racional(pref,oQue){
  var w=(pref&&pref.w)||wilson(0,0);
  if(!w.n) return {linhas:[["Observações","nenhuma"]],
    nota:"Sem itens sincronizados para este cliente — nada a inferir sobre "+oQue+"."};
  var r=[
    ["Observado",NUM(w.k)+" de "+NUM(w.n)+" ("+PCT0(w.p)+")"],
    ["Intervalo 95%",ciTxt(w),"hl"],
    ["Esperado por acaso",PCT0(pref.acaso)+" ("+pref.opcoes+" opções)"],
    [null],
    ["Critério","limite inferior > acaso"],
    ["Veredito",pref.conclusivo?"preferência sustentada":"inconclusivo",pref.conclusivo?"good":"bad"]
  ];
  var nota;
  if(pref.empate) nota="Empate em "+NUM(pref.top.n)+" — "+oQue+" não tem vencedor. Escolher um seria ordenação de array, não tendência.";
  else if(pref.margemUnica) nota="Diferença de uma unidade só em amostra de "+w.n+". Dentro do erro amostral: pode inverter com a próxima compra.";
  else if(!pref.conclusivo) nota="O intervalo de 95% inclui o que se esperaria por acaso. Insuficiente para afirmar preferência.";
  else nota="O intervalo inteiro está acima do acaso, então a preferência se sustenta com "+w.n+" observações.";
  return {linhas:r,nota:nota};
}
/* rótulo curto exibido junto do valor quando a inferência é fraca */
function selo(pref){
  if(pref.vazio) return "";
  if(pref.empate) return '<span class="cid-flag">empate</span>';
  if(!pref.conclusivo) return '<span class="cid-flag">n='+pref.w.n+' · inconclusivo</span>';
  return '<span class="cid-flag ok">n='+pref.w.n+' · '+pref.conf.curto+'</span>';
}
/* valor a exibir: só nomeia o vencedor quando há vencedor */
function valorPref(pref,sufixo){
  if(pref.vazio) return "—";
  if(pref.empate) return esc(pref.top.k)+" / "+esc(pref.seg.k);
  return esc(pref.top.k)+(sufixo||"");
}

/* ---- tooltip declarativo: qualquer elemento vira interativo ----
   tipRows("Título",[[label,valor,classe] | [null] p/ separador],"nota") */
function tipRows(head,rows,note){
  var payload=JSON.stringify({h:head||"",r:rows||[],n:note||""});
  return ' data-tip="rows" data-rows="'+esc(payload)+'"';
}

/* ---- geografia (mesmo mapa da página de listagem) ---- */
var UF_REGIAO={AC:"Norte",AP:"Norte",AM:"Norte",PA:"Norte",RO:"Norte",RR:"Norte",TO:"Norte",
  AL:"Nordeste",BA:"Nordeste",CE:"Nordeste",MA:"Nordeste",PB:"Nordeste",PE:"Nordeste",PI:"Nordeste",RN:"Nordeste",SE:"Nordeste",
  DF:"Centro-Oeste",GO:"Centro-Oeste",MT:"Centro-Oeste",MS:"Centro-Oeste",
  ES:"Sudeste",MG:"Sudeste",RJ:"Sudeste",SP:"Sudeste",PR:"Sul",RS:"Sul",SC:"Sul"};
var NOME_UF={"acre":"AC","alagoas":"AL","amapá":"AP","amapa":"AP","amazonas":"AM","bahia":"BA","ceará":"CE","ceara":"CE",
  "distrito federal":"DF","espírito santo":"ES","espirito santo":"ES","goiás":"GO","goias":"GO","maranhão":"MA","maranhao":"MA",
  "mato grosso":"MT","mato grosso do sul":"MS","minas gerais":"MG","pará":"PA","para":"PA","paraíba":"PB","paraiba":"PB",
  "paraná":"PR","parana":"PR","pernambuco":"PE","piauí":"PI","piaui":"PI","rio de janeiro":"RJ",
  "rio grande do norte":"RN","rio grande do sul":"RS","rondônia":"RO","rondonia":"RO","roraima":"RR",
  "santa catarina":"SC","são paulo":"SP","sao paulo":"SP","sergipe":"SE","tocantins":"TO"};
function ufOf(e){var s=String(e||"").trim();if(!s)return"";if(s.length===2)return s.toUpperCase();return NOME_UF[s.toLowerCase()]||"";}
function regiaoOf(e){return UF_REGIAO[ufOf(e)]||"";}

var CANAL_COR={Instagram:"#e1306c",Facebook:"#1877f2",Google:"#ea4335",TikTok:"#00f2ea",Direto:"#8a8a8a",
  Email:"#f5a623",Whatsapp:"#25d366","Orgânico":"#48f91e","Tráfego":"#1877f2"};
/* cor de marca só onde ela informa (o ponto do canal); o resto fica neutro */
function canalCor(n){return CANAL_COR[n]||"#8a8a8a";}

var WD=["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];
var WD_LONGO=["domingo","segunda","terça","quarta","quinta","sexta","sábado"];

function getId(){try{return new URLSearchParams(window.location.search).get("id")||"";}catch(e){var m=window.location.search.match(/[?&]id=([^&]+)/);return m?decodeURIComponent(m[1]):"";}}
function fail(m){var e=document.getElementById("mc-err");e.hidden=false;e.textContent="Erro: "+m;var l=document.getElementById("mc-loading");if(l)l.style.display="none";}

/* ============================ SKELETON ============================ */
function skeletonHtml(){
  function ln(w,h){return '<span class="skl-ln" style="width:'+w+';height:'+(h||10)+'px"></span>';}
  function cell(){return '<div class="skl-cell">'+ln('55%')+ln('75%',16)+'</div>';}
  function panel(bodyH,inner,cls){return '<div class="cid-panel skl-panel '+(cls||'')+'"><div class="cid-panel-head">'+ln('150px',11)+'</div><div class="cid-panel-body" style="min-height:'+bodyH+'px">'+(inner||'')+'</div></div>';}
  var kpis='<div class="cid-kpi-row skl-panel">'+new Array(9).join('x').split('x').map(function(){return '<div class="cid-kpi">'+ln('62%',9)+ln('82%',18)+'</div>';}).join('')+'</div>';
  function rows(n,w){var o='';for(var i=0;i<n;i++)o+='<div class="skl-row">'+ln('38%')+ln(w||'32%')+'</div>';return '<div class="skl-rows">'+o+'</div>';}
  var fin='<div class="skl-grid c4">'+new Array(9).join('x').split('x').map(cell).join('')+'</div>';
  var bars='<div class="skl-bars">'+[60,90,45,75,30,55,80,40,65,50,70,35].map(function(h){return '<span class="skl-bar" style="height:'+h+'%"></span>';}).join('')+'</div>';
  var hero='<div class="cid-hero">'+panel(300,rows(9))+'<div class="cid-hero-side">'+panel(140,fin)+panel(150,rows(5,'26%'))+'</div></div>';
  var gi=panel(160,'<div class="skl-grid c6">'+new Array(13).join('x').split('x').map(cell).join('')+'</div>');
  var duo='<div class="cid-2col">'+panel(258,rows(6))+panel(258,rows(6))+'</div>';
  var cmp=panel(230,'<div class="skl-grid c4">'+new Array(9).join('x').split('x').map(cell).join('')+'</div>');
  var tbl=panel(230,new Array(8).join('x').split('x').map(function(){return '<div class="skl-row">'+ln('11%')+ln('9%')+ln('8%')+ln('12%')+ln('10%')+ln('10%')+ln('14%')+'</div>';}).join(''));
  return '<div class="cid-skeleton">'+kpis+hero+panel(240,bars)+gi+duo+duo+cmp+tbl+'</div>';
}

/* ============================ BOOT ============================ */
var id=getId();
if(!id){document.getElementById("mc-loading").textContent="Nenhum cliente na URL (?id=)";return;}

var BOOT_KEY="cli_boot_"+id, BASE_KEY="mc_cli_base_v1";
var D=null, BASE=null, _rendered=false, _got={};

function bootBase(){
  try{ var b=JSON.parse(localStorage.getItem(BASE_KEY)); if(b&&b.d&&b.d.customers) return b.d; }catch(e){}
  return null;
}
(function(){
  BASE=bootBase();
  var cached=false;
  try{
    var c=JSON.parse(localStorage.getItem(BOOT_KEY));
    if(c&&c.d&&c.d.row){ cached=true; D=c.d; paint(); }   // instantâneo
  }catch(e){}
  if(!cached){
    var l=document.getElementById("mc-loading"); if(l)l.style.display="none";
    document.getElementById("mc-client-wrap").innerHTML=skeletonHtml();
  }
})();

function saveBoot(){
  if(!_got.d) return;
  try{ localStorage.setItem(BOOT_KEY,JSON.stringify({ts:Date.now(),d:_got.d})); }catch(e){}
}
function tryPaint(){
  if(_got.d){ D=_got.d; }
  if(_got.base){ BASE=_got.base; }
  if(!D) return;
  paint(); saveBoot();
}
/* ORDEM IMPORTA. O Apps Script enfileira execuções simultâneas do mesmo usuário
   no mesmo script: disparar os três juntos fazia o customer_analytics (que é quem
   desenha a página) esperar atrás do customer_base, que é o mais pesado.
   Agora só o analytics sai no carregamento; o resto vai depois de pintar. */
var _secundariosOk=false;
function secundarios(){
  if(_secundariosOk) return;
  _secundariosOk=true;

  /* base: se veio do prefetch e está fresca, nem rebusca agora */
  var baseFresca=false;
  try{
    var b0=JSON.parse(localStorage.getItem(BASE_KEY));
    baseFresca=!!(b0&&b0.ts&&(Date.now()-b0.ts)<15*60000&&b0.d&&b0.d.customers);
  }catch(e){}
  var atrasoBase=baseFresca?20000:400;

  setTimeout(function(){
    /* 60s: numa loja com muito histórico o primeiro cálculo é lento, e desistir
       cedo demais significa nunca gravar o cache local */
    call({resource:"customer_base"},60000).then(function(b){
      if(!b||b.error||!b.customers) return;
      _got.base=b;
      try{ localStorage.setItem(BASE_KEY,JSON.stringify({ts:Date.now(),d:b})); }catch(e){}
      tryPaint();
    }).catch(function(){});
  },atrasoBase);

  /* nascimento: depende do Yampi, então vai por último e nunca segura nada */
  setTimeout(function(){
    call({resource:"customer_extra",id:id}).then(function(x){
      if(!x||x.error||!x.nascimento) return;
      if(_got.d&&_got.d.row) _got.d.row.nascimento=x.nascimento;
      if(D&&D.row) D.row.nascimento=x.nascimento;
      if(_rendered) paint();
      saveBoot();
    }).catch(function(){});
  },atrasoBase+1200);
}

call({resource:"customer_analytics",id:id}).then(function(d){
  if(d&&d.error){ if(!_rendered) fail(d.error); secundarios(); return; }
  if(!d||!d.row){
    if(!_rendered){ var l=document.getElementById("mc-loading"); if(l){l.style.display="";l.textContent="Cliente não encontrado.";} document.getElementById("mc-client-wrap").innerHTML=""; }
    return;
  }
  _got.d=d; tryPaint(); secundarios();
}).catch(function(e){ if(!_rendered) fail(e.message+" — recarregue a página."); secundarios(); });

/* rede de segurança: se o analytics demorar demais, os secundários saem assim mesmo */
setTimeout(secundarios,12000);

function paint(){
  var l=document.getElementById("mc-loading"); if(l)l.style.display="none";
  /* o render roda dentro do .then() do JSONP: sem este try/catch, qualquer erro
     de renderização viraria o .catch da chamada e apareceria como erro de rede */
  try{
    render(computeAll(D,BASE));
    _rendered=true;
  }catch(e){
    if(window.console&&console.error) console.error("[mc-cliente] falha ao renderizar:",e);
    if(!_rendered) fail("falha ao montar a página ("+(e&&e.message||e)+")");
  }
}

/* ==========================================================================
   MOTOR DE ANÁLISE — tudo que a página e os insights consomem sai daqui
   ========================================================================== */
var STATUS_RUIM={"cancelado":1,"devolvido":1,"não pago":1,"nao pago":1,"estornado":1};
function pago(o){ return !STATUS_RUIM[String(o.status||"").toLowerCase()]; }

function computeAll(d,base){
  var c=d.row||{}, allOrders=(d.orders||[]).slice(), items=(d.items||[]).slice();
  var devs=(d.devolucoes&&d.devolucoes.rows)||[], devItens=(d.devolucoes&&d.devolucoes.itens)||[];
  var M={ c:c, base:base||null, allOrders:allOrders, items:items, devs:devs, devItens:devItens };

  /* --- pedidos válidos, do mais novo para o mais antigo --- */
  var ords=allOrders.filter(pago).sort(function(a,b){ return new Date(b.created_at||0)-new Date(a.created_at||0); });
  var asc=ords.slice().reverse();
  M.ords=ords; M.asc=asc;
  M.n=ords.length;
  M.nCancelados=allOrders.length-ords.length;

  /* --- dinheiro --- */
  var sum=function(f){ var s=0; ords.forEach(function(o){ s+=nz(o[f]); }); return s; };
  M.ltv       = sum("faturamento") || nz(c.valor_gasto);
  M.lucro     = sum("lucro");
  M.custo     = sum("custo_total");
  M.cogs      = sum("cogs");
  M.desconto  = sum("desconto");
  M.freteCob  = sum("frete_cobrado");
  M.freteReal = sum("frete_real");
  M.fretePago = sum("frete_pago");
  M.taxa      = sum("taxa_gateway");
  M.itensQtd  = sum("itens_qtd") || items.reduce(function(s,i){ return s+nz(i.quantity); },0);
  M.ticket    = M.n ? M.ltv/M.n : 0;
  M.margem    = M.ltv ? M.lucro/M.ltv : 0;
  M.lucroPed  = M.n ? M.lucro/M.n : 0;
  M.itensPed  = M.n ? M.itensQtd/M.n : 0;
  M.descPct   = M.ltv ? M.desconto/(M.ltv+M.desconto) : 0;
  M.freteMed  = M.n ? M.freteCob/M.n : 0;
  M.fretePctTicket = M.ticket ? M.freteMed/M.ticket : 0;

  /* --- descontos e cupons --- */
  var comDesc=0, comCupom=0, freteGratis=0, maiorDesc=0, cupomUso={};
  var recDesc=0, recCheia=0;
  ords.forEach(function(o){
    var dsc=nz(o.desconto), fat=nz(o.faturamento);
    if(dsc>0){ comDesc++; recDesc+=fat; } else recCheia+=fat;
    if(dsc>maiorDesc) maiorDesc=dsc;
    var cp=String(o.cupom||"").trim();
    if(cp && cp!=="-"){ comCupom++; cupomUso[cp]=(cupomUso[cp]||0)+1; }
    if(String(o.frete_gratis||"")==="Sim") freteGratis++;
  });
  M.pctComDesconto=M.n?comDesc/M.n:0;
  M.pctComCupom  =M.n?comCupom/M.n:0;
  M.pctFreteGratis=M.n?freteGratis/M.n:0;
  M.maiorDesconto=maiorDesc;
  M.descontoMedio=M.n?M.desconto/M.n:0;
  M.receitaComDesconto=recDesc; M.receitaPrecoCheio=recCheia;
  M.pctReceitaPromo=M.ltv?recDesc/M.ltv:0;
  M.cupons=Object.keys(cupomUso).sort(function(a,b){ return cupomUso[b]-cupomUso[a]; });
  M.cupomTop=M.cupons[0]||"";
  M.cupomTopN=M.cupomTop?cupomUso[M.cupomTop]:0;
  M.cupomUso=cupomUso;

  /* --- datas, ciclo e recorrência --- */
  var primeira=asc[0]&&asc[0].created_at, ultima=ords[0]&&ords[0].created_at;
  M.primeira=primeira||c.primeira_compra||"";
  M.ultima  =ultima  ||c.ultima_compra||"";
  M.diasUltima=daysAgo(M.ultima);
  M.diasCliente=daysAgo(M.primeira);
  M.mesesCliente=M.diasCliente!=null?Math.max(1,Math.round(M.diasCliente/30)):0;
  var gaps=[];
  for(var i=1;i<asc.length;i++){
    var g=Math.round((new Date(asc[i].created_at)-new Date(asc[i-1].created_at))/86400000);
    if(g>=0) gaps.push(g);
  }
  M.gaps=gaps;
  var gs=gaps.slice().sort(function(a,b){return a-b;});
  M.gapMedio  = gaps.length? gaps.reduce(function(a,b){return a+b;},0)/gaps.length : 0;
  M.gapMediana= gs.length? gs[Math.floor(gs.length/2)] : 0;
  M.gapMin    = gs.length? gs[0] : 0;
  M.gapMax    = gs.length? gs[gs.length-1] : 0;
  M.gap1a2    = gaps.length? gaps[0] : 0;
  M.gapUltimo = gaps.length? gaps[gaps.length-1] : 0;
  var ciclo=M.gapMediana||M.gapMedio||0;
  M.ciclo=ciclo;
  M.cicloRatio = (ciclo>0 && M.diasUltima!=null) ? M.diasUltima/ciclo : 0;
  M.freqMes = M.diasCliente ? (M.n/Math.max(1,M.diasCliente/30)) : nz(c.frequencia_mes);
  /* aceleração: média dos 3 últimos intervalos vs 3 primeiros */
  if(gaps.length>=4){
    var g0=gaps.slice(0,Math.min(3,Math.floor(gaps.length/2)));
    var g1=gaps.slice(-Math.min(3,Math.floor(gaps.length/2)));
    var m0=g0.reduce(function(a,b){return a+b;},0)/g0.length;
    var m1=g1.reduce(function(a,b){return a+b;},0)/g1.length;
    M.tendCiclo = m0? (m1-m0)/m0 : 0;   // <0 = comprando mais junto
  } else M.tendCiclo=0;
  /* reativações: intervalos maiores que 2,5× o ciclo */
  M.reativacoes = ciclo>0 ? gaps.filter(function(g){ return g>ciclo*2.5; }).length : 0;
  M.janelaIni = ciclo? Math.round(ciclo*0.8) : 0;
  M.janelaFim = ciclo? Math.round(ciclo*1.2) : 0;

  /* --- evolução do gasto --- */
  M.ticketPrimeiro = asc[0]? nz(asc[0].faturamento):0;
  M.ticketUltimo   = ords[0]? nz(ords[0].faturamento):0;
  function mediaFat(arr){ return arr.length? arr.reduce(function(s,o){return s+nz(o.faturamento);},0)/arr.length : 0; }
  M.media3Primeiros = mediaFat(asc.slice(0,3));
  M.media3Ultimos   = mediaFat(asc.slice(-3));
  M.tendTicket = M.media3Primeiros? (M.media3Ultimos-M.media3Primeiros)/M.media3Primeiros : 0;
  M.maiorPedido = ords.reduce(function(a,o){ return (!a||nz(o.faturamento)>nz(a.faturamento))?o:a; }, null);
  M.menorPedido = ords.reduce(function(a,o){ return (!a||nz(o.faturamento)<nz(a.faturamento))?o:a; }, null);

  /* --- tempo --- */
  var wd=[0,0,0,0,0,0,0], hr=[], k;
  for(k=0;k<24;k++) hr.push(0);
  var wdRec=[0,0,0,0,0,0,0];
  ords.forEach(function(o){
    if(!o.created_at) return;
    var dt=new Date(o.created_at); if(isNaN(dt)) return;
    wd[dt.getDay()]++; wdRec[dt.getDay()]+=nz(o.faturamento); hr[dt.getHours()]++;
  });
  M.wd=wd; M.wdRec=wdRec; M.hr=hr;
  M.bestWd=wd.indexOf(Math.max.apply(null,wd));
  M.bestHr=hr.indexOf(Math.max.apply(null,hr));
  M.fimDeSemana=wd[0]+wd[6]; M.diasUteis=wd[1]+wd[2]+wd[3]+wd[4]+wd[5];
  var noite=0; for(k=19;k<24;k++) noite+=hr[k];
  M.pctNoite=M.n?noite/M.n:0;
  /* faixa horária dominante */
  var faixas=[["Madrugada",0,5],["Manhã",6,11],["Tarde",12,17],["Noite",18,23]];
  var topFaixa=null;
  faixas.forEach(function(f){
    var s=0; for(var h=f[1];h<=f[2];h++) s+=hr[h];
    if(!topFaixa||s>topFaixa.n) topFaixa={lbl:f[0],n:s};
  });
  M.faixaHoraria=topFaixa||{lbl:"—",n:0};
  M.pctFaixa=M.n&&topFaixa?topFaixa.n/M.n:0;

  /* --- pagamento --- */
  var pay={};
  ords.forEach(function(o){ var m=String(o.metodo_pagamento||"").trim()||"—"; pay[m]=(pay[m]||0)+1; });
  M.pagamentos=pay;
  M.pagTop=Object.keys(pay).sort(function(a,b){return pay[b]-pay[a];})[0]||"—";

  /* --- canal / aquisição --- */
  function canalDe(o){
    var s=String(o.origem||"").trim();
    if(!s||s==="-") return "Direto";
    return cap(s);
  }
  var canal={}, canalRec={};
  ords.forEach(function(o){ var k2=canalDe(o); canal[k2]=(canal[k2]||0)+1; canalRec[k2]=(canalRec[k2]||0)+nz(o.faturamento); });
  M.canais=Object.keys(canal).map(function(k2){ return {canal:k2,pedidos:canal[k2],receita:canalRec[k2],pct:M.n?canal[k2]/M.n:0}; })
    .sort(function(a,b){ return b.pedidos-a.pedidos; });
  M.canalTop=M.canais[0]||null;
  M.firstTouch = asc[0] ? (String(asc[0].campanha_sessao||"").trim() || canalDe(asc[0])) : (String(c.origem_primeira||"")||"—");
  M.canalPrimeiro = asc[0]? canalDe(asc[0]) : (cap(String(c.origem_primeira||""))||"—");
  M.canalUltimo   = ords[0]? canalDe(ords[0]) : "—";
  M.campanhaPrimeira = asc[0] ? (String(asc[0].campanha_sessao||asc[0].campanha||"").trim()) : "";
  M.anuncioPrimeiro  = asc[0] ? (String(asc[0].anuncio_sessao||asc[0].anuncio||"").trim()) : "";
  M.cupomPrimeiro    = asc[0] ? String(asc[0].cupom||"").trim() : "";
  /* jornada: canal de cada pedido em ordem cronológica (comprimido) */
  var jornada=[];
  asc.forEach(function(o){ var k2=canalDe(o); if(!jornada.length||jornada[jornada.length-1]!==k2) jornada.push(k2); });
  M.jornada=jornada;
  M.mudouCanal = jornada.length>1;
  M.diretoAgora = M.n>=2 && (function(){ var ult=asc.slice(-Math.max(1,Math.ceil(asc.length/2))); var dir=0; ult.forEach(function(o){ if(canalDe(o)==="Direto") dir++; }); return dir/ult.length; })();

  /* --- itens: produto, categoria, tamanho, cor, coleção, faixa de preço --- */
  function tally(list,keyFn,valFn){
    var m={};
    list.forEach(function(it){
      var k2=keyFn(it); if(!k2||k2==="—") return;
      var b=m[k2]||(m[k2]={k:k2,n:0,rec:0,pedidos:{}});
      b.n+=nz(it.quantity)||1; b.rec+=valFn?valFn(it):nz(it.line_revenue);
      b.pedidos[String(it.order_id)]=1;
    });
    return Object.keys(m).map(function(k2){ var b=m[k2]; b.nPedidos=Object.keys(b.pedidos).length; delete b.pedidos; return b; })
      .sort(function(a,b){ return b.n-a.n || b.rec-a.rec; });
  }
  var okOrders={}; ords.forEach(function(o){ okOrders[String(o.id)]=1; });
  var its=items.filter(function(it){ return okOrders[String(it.order_id)]; });
  M.its=its;
  M.produtos  = tally(its,function(it){ return String(it.link_id||it.product_id||""); });
  M.produtos.forEach(function(p){
    var ex=its.filter(function(it){ return String(it.link_id||it.product_id||"")===p.k; })[0];
    p.nome=ex?(ex.nome_exibicao||ex.title||p.k):p.k;
    p.cat =ex?ex.categoria:"";
  });
  M.categorias= tally(its,function(it){ return String(it.categoria||""); });
  M.tamanhos  = tally(its,function(it){ return String(it.tamanho||"").toUpperCase(); });
  M.cores     = tally(its,function(it){ return String(it.cor||""); });
  M.colecoes  = tally(its,function(it){ return String(it.colecao||""); });
  M.unidades  = its.reduce(function(s,it){ return s+(nz(it.quantity)||1); },0);
  M.skusUnicos= (function(){ var s={}; its.forEach(function(it){ if(it.sku) s[it.sku]=1; }); return Object.keys(s).length; })();
  M.prodTop   = M.produtos[0]||null;
  M.catTop    = M.categorias[0]||null;
  M.tamTop    = M.tamanhos[0]||null;
  M.corTop    = M.cores[0]||null;
  M.dropTop   = M.colecoes[0]||null;
  M.concentracaoCat = (M.catTop&&M.unidades)? M.catTop.n/M.unidades : 0;
  M.concentracaoProd= (M.prodTop&&M.unidades)? M.prodTop.n/M.unidades : 0;
  M.concentracaoTam = (M.tamTop&&M.unidades)? M.tamTop.n/M.unidades : 0;
  M.recompraSku = M.produtos.filter(function(p){ return p.nPedidos>1; }).length;
  /* preço médio por item e desconto implícito vs preço cheio de catálogo */
  var somaPreco=0, somaQtd=0, somaCheio=0;
  its.forEach(function(it){
    var q=nz(it.quantity)||1;
    somaPreco+=nz(it.price)*q; somaQtd+=q;
    somaCheio+=(nz(it.preco_cheio)||nz(it.price))*q;
  });
  M.precoMedioItem=somaQtd?somaPreco/somaQtd:0;
  M.precoCheioMedio=somaQtd?somaCheio/somaQtd:0;
  M.descontoImplicito=somaCheio?(somaCheio-somaPreco)/somaCheio:0;
  /* faixa de preço favorita */
  var FAIXAS=[["até R$100",0,100],["R$100–150",100,150],["R$150–200",150,200],["R$200–300",200,300],["R$300+",300,1e9]];
  var faixaN={};
  its.forEach(function(it){
    var p=nz(it.price); var q=nz(it.quantity)||1;
    for(var f=0;f<FAIXAS.length;f++){ if(p>=FAIXAS[f][1]&&p<FAIXAS[f][2]){ faixaN[FAIXAS[f][0]]=(faixaN[FAIXAS[f][0]]||0)+q; break; } }
  });
  M.faixaPreco=Object.keys(faixaN).sort(function(a,b){return faixaN[b]-faixaN[a];})[0]||"—";
  /* primeiro produto / primeira categoria */
  var primeiroPed=asc[0]?String(asc[0].id):"";
  var itsPrimeiro=its.filter(function(it){ return String(it.order_id)===primeiroPed; });
  M.primeiroProduto = itsPrimeiro[0]? (itsPrimeiro[0].nome_exibicao||itsPrimeiro[0].title||"") : "";
  M.primeiroProdutoId = itsPrimeiro[0]? String(itsPrimeiro[0].link_id||itsPrimeiro[0].product_id||"") : "";
  M.primeiraCategoria = itsPrimeiro[0]? String(itsPrimeiro[0].categoria||"") : "";
  /* sequência de categorias, um passo por pedido */
  var seqCat=[];
  asc.forEach(function(o){
    var li=its.filter(function(it){ return String(it.order_id)===String(o.id); });
    if(!li.length) return;
    var cnt={}; li.forEach(function(it){ var k2=it.categoria||"—"; cnt[k2]=(cnt[k2]||0)+(nz(it.quantity)||1); });
    var top=Object.keys(cnt).sort(function(a,b){return cnt[b]-cnt[a];})[0];
    seqCat.push(top);
  });
  M.seqCat=seqCat;
  /* consistência de tamanho + tamanho por categoria */
  var tamPorCat={};
  its.forEach(function(it){
    var cat2=String(it.categoria||"—"), t=String(it.tamanho||"").toUpperCase(); if(!t) return;
    var b=tamPorCat[cat2]||(tamPorCat[cat2]={});
    b[t]=(b[t]||0)+(nz(it.quantity)||1);
  });
  M.tamPorCat=Object.keys(tamPorCat).map(function(cat2){
    var b=tamPorCat[cat2];
    var top=Object.keys(b).sort(function(a,b2){return b[b2]-b[a];})[0];
    return {cat:cat2,tam:top,n:b[top]};
  });
  M.tamanhosDistintos=M.tamanhos.length;

  /* --- devoluções e trocas --- */
  M.nDev=devs.filter(function(r){ return String(r.tipo)!=="troca"; }).length;
  M.nTroca=devs.filter(function(r){ return String(r.tipo)==="troca"; }).length;
  M.devTotal=M.nDev+M.nTroca;
  M.taxaDev=M.n?M.devTotal/M.n:0;
  M.valorDevolvido=devs.reduce(function(s,r){ return s+nz(r.valor_itens); },0);
  M.custoDevLog=devs.reduce(function(s,r){ return s+nz(r.custo_logistico)+nz(r.custo_reenvio); },0);
  M.lucroLiquido=M.lucro-M.custoDevLog;
  var motivos={}, tamDev={};
  devs.forEach(function(r){ var m=String(r.motivo||"").trim(); if(m) motivos[m]=(motivos[m]||0)+1; });
  devItens.forEach(function(r){ var t=String(r.tamanho||"").toUpperCase(); if(t) tamDev[t]=(tamDev[t]||0)+1; });
  M.motivoTop=Object.keys(motivos).sort(function(a,b){return motivos[b]-motivos[a];})[0]||"";
  M.motivoTopN=M.motivoTop?motivos[M.motivoTop]:0;
  M.tamDevTop=Object.keys(tamDev).sort(function(a,b){return tamDev[b]-tamDev[a];})[0]||"";
  M.tamDevTopN=M.tamDevTop?tamDev[M.tamDevTop]:0;
  M.problemaTamanho=/tamanho/i.test(M.motivoTop||"");

  /* --- aniversário --- */
  M.nascimento=String(c.nascimento||"");
  M.aniversario=null;
  if(M.nascimento){
    var mm=M.nascimento.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if(mm){
      var hoje=new Date(), hj=new Date(hoje.getFullYear(),hoje.getMonth(),hoje.getDate());
      var prox=new Date(hj.getFullYear(),+mm[2]-1,+mm[3]);
      if(prox<hj) prox=new Date(hj.getFullYear()+1,+mm[2]-1,+mm[3]);
      M.aniversario={
        data:mm[3]+"/"+mm[2]+"/"+mm[1],
        dia:mm[3]+"/"+mm[2],
        dias:Math.round((prox-hj)/86400000),
        idade:hj.getFullYear()-(+mm[1])-((hj.getMonth()<+mm[2]-1||(hj.getMonth()===+mm[2]-1&&hj.getDate()<+mm[3]))?1:0)
      };
    }
  }

  /* --- comparação com a base --- */
  computeBase(M,base);
  /* --- RFM, score e predições (dependem dos percentis) --- */
  computeRFM(M);
  computeScore(M);
  computePred(M);
  return M;
}

/* posição do cliente dentro da base: rank, percentil e médias */
function computeBase(M,base){
  M.hasBase=!!(base&&base.customers&&base.customers.length);
  /* enquanto customer_base não responde a página renderiza mesmo assim:
     tudo que depende da base fica neutro e os blocos comparativos se escondem */
  if(!M.hasBase){
    M.rank={}; M.avg={}; M.pctl={}; M.faixa={}; M.total=0;
    M.storeAvg={}; M.intervals={}; M.coorte={};
    M.shareReceita=0; M.shareLucro=0; M.ltvEsperado=0; M.gapLtv=0;
    M.regiaoStats=null; M.cidadeStats=null;
    M.proximaCat=null; M.nuncaComprou=[]; M.catNaoExplorada=null;
    return;
  }
  var cs=base.customers;
  var N=cs.length;
  function rankOf(get,v){ var acima=0; for(var i=0;i<N;i++){ if(get(cs[i])>v) acima++; } return acima+1; }
  function mediaDe(get){ var s=0; for(var i=0;i<N;i++) s+=nz(get(cs[i])); return N?s/N:0; }
  function faixa(get){ var mn=Infinity,mx=-Infinity; for(var i=0;i<N;i++){ var v=nz(get(cs[i])); if(v<mn)mn=v; if(v>mx)mx=v; } return isFinite(mn)?{min:mn,max:mx}:null; }
  var gv=function(x){return nz(x.v);}, gl=function(x){return nz(x.l);}, gt=function(x){return nz(x.t);},
      gn=function(x){return nz(x.n);}, gm=function(x){return nz(x.m);}, gf=function(x){return nz(x.f);};

  M.total=N;
  M.rank={
    receita:rankOf(gv,M.ltv), lucro:rankOf(gl,M.lucro),
    pedidos:rankOf(gn,M.n),   ticket:rankOf(gt,M.ticket)
  };
  M.pctl={
    receita:1-(M.rank.receita-1)/N, lucro:1-(M.rank.lucro-1)/N,
    pedidos:1-(M.rank.pedidos-1)/N, ticket:1-(M.rank.ticket-1)/N
  };
  M.avg={
    ltv:mediaDe(gv), lucro:mediaDe(gl), ticket:mediaDe(gt),
    pedidos:mediaDe(gn), margem:mediaDe(gm), freq:mediaDe(gf)
  };
  M.faixa={ ltv:faixa(gv), lucro:faixa(gl), ticket:faixa(gt), pedidos:faixa(gn), margem:faixa(gm) };
  M.shareReceita = base.total_revenue ? M.ltv/base.total_revenue : 0;
  M.shareLucro   = base.total_profit  ? M.lucro/base.total_profit : 0;
  M.storeAvg = base.storeAvg||{};
  M.intervals= base.intervals||{};

  /* coortes */
  var co=base.cohorts||{};
  var mesKey=String(M.primeira||"").slice(0,7);
  M.coorte={
    mes:      (co.byMonth||{})[mesKey]||null,        mesKey:mesKey,
    canal:    (co.byChannel||{})[String(M.c.origem_primeira||"")]||null,
    regiao:   (co.byRegion||{})[regiaoOf(M.c.estado)]||null,
    produto:  (co.byFirstProduct||{})[M.primeiroProdutoId]||null
  };
  /* clientes da mesma região / mesma coorte de aquisição — médias diretas */
  var rg=regiaoOf(M.c.estado), ci=String(M.c.cidade||"").toLowerCase();
  var mesmaRegiao=[], mesmaCidade=[];
  for(var i=0;i<N;i++){
    if(rg && cs[i].rg===rg) mesmaRegiao.push(cs[i]);
    if(ci && String(cs[i].ci||"").toLowerCase()===ci) mesmaCidade.push(cs[i]);
  }
  function med(arr,get){ if(!arr.length) return 0; var s=0; arr.forEach(function(x){ s+=nz(get(x)); }); return s/arr.length; }
  M.regiaoStats={ n:mesmaRegiao.length, ticket:med(mesmaRegiao,gt), ltv:med(mesmaRegiao,gv) };
  M.cidadeStats={ n:mesmaCidade.length, ticket:med(mesmaCidade,gt), ltv:med(mesmaCidade,gv),
    rank:(function(){ var a=0; mesmaCidade.forEach(function(x){ if(nz(x.v)>M.ltv) a++; }); return a+1; })() };

  /* PRÓXIMA CATEGORIA PROVÁVEL
     Não basta "38% compram boné depois de camiseta". Se 38% de TODOS os pedidos
     da loja já são boné, esse número não informa nada sobre a sequência — seria
     confundir frequência de catálogo com padrão de jornada (erro tipo I).
     Então: comparamos a taxa condicional contra a taxa incondicional da loja,
     com intervalo de Wilson, e só afirmamos quando o intervalo fica acima. */
  var seq=(base.seq&&base.seq.next)||{};
  var ultimaCat=M.seqCat.length?M.seqCat[M.seqCat.length-1]:"";
  M.proximaCat=null;
  /* taxa incondicional de cada categoria = linha de base */
  var catTot=0, catShare={};
  ((base.popular&&base.popular.categorias)||[]).forEach(function(x){ catTot+=nz(x.n); });
  ((base.popular&&base.popular.categorias)||[]).forEach(function(x){ catShare[x.c]=catTot?nz(x.n)/catTot:0; });

  if(ultimaCat && seq[ultimaCat]){
    var alvo=seq[ultimaCat], tot=0;
    Object.keys(alvo).forEach(function(k){ tot+=alvo[k]; });
    var ord=Object.keys(alvo).sort(function(a,b){ return alvo[b]-alvo[a]; });
    /* avalia TODOS os destinos e fica com o de maior evidência, não o de maior %.
       O destino "repetir a mesma categoria" entra também: às vezes é a verdade. */
    var melhor=null;
    ord.forEach(function(cat){
      var k=alvo[cat], p0=catShare[cat]||0;
      var t=vsBase(k,tot,p0);
      var cand={ cat:cat, k:k, n:tot, p:t.w.p, lo:t.w.lo, hi:t.w.hi, p0:p0,
        lift:t.lift, signif:t.acima, de:ultimaCat, repete:(cat===ultimaCat) };
      /* prioridade: significante primeiro; entre iguais, maior lift */
      if(!melhor) melhor=cand;
      else if(cand.signif&&!melhor.signif) melhor=cand;
      else if(cand.signif===melhor.signif&&cand.lift>melhor.lift) melhor=cand;
    });
    /* amostra mínima da matriz: abaixo disso nem vale mostrar */
    if(melhor && tot>=15) M.proximaCat=melhor;
  }
  /* populares que ele nunca comprou */
  var comprados={}; M.produtos.forEach(function(p){ comprados[p.k]=1; });
  var catComprada={}; M.categorias.forEach(function(x){ catComprada[x.k]=1; });
  M.nuncaComprou=((base.popular&&base.popular.produtos)||[]).filter(function(p){ return !comprados[String(p.id)]; }).slice(0,5);
  M.catNaoExplorada=((base.popular&&base.popular.categorias)||[]).filter(function(x){ return !catComprada[x.c] && x.c!=="—"; })[0]||null;

  /* potencial: LTV médio dos clientes com nº de pedidos semelhante, um degrau acima */
  var pares=[];
  for(i=0;i<N;i++){ if(nz(cs[i].n)>=M.n && nz(cs[i].n)<=M.n+2) pares.push(cs[i]); }
  M.ltvEsperado = pares.length>=5 ? med(pares,gv) : M.avg.ltv;
  M.gapLtv = M.ltvEsperado-M.ltv;
}

/* RFM com quintis reais da base */
function computeRFM(M){
  if(!M.hasBase){ M.rfm=null; return; }
  var cs=M.base.customers;
  function quintil(vals,v,inverso){
    vals=vals.slice().sort(function(a,b){return a-b;});
    var abaixo=0; for(var i=0;i<vals.length;i++){ if(vals[i]<v) abaixo++; }
    var p=vals.length?abaixo/vals.length:0;
    var s=clamp(Math.floor(p*5)+1,1,5);
    return inverso?(6-s):s;
  }
  var recVals=[], freqVals=[], monVals=[];
  cs.forEach(function(x){ recVals.push(nz(x.d)); freqVals.push(nz(x.n)); monVals.push(nz(x.v)); });
  var R=quintil(recVals, M.diasUltima==null?9999:M.diasUltima, true);
  var F=quintil(freqVals, M.n, false);
  var Mo=quintil(monVals, M.ltv, false);
  var seg;
  if(R>=4&&F>=4&&Mo>=4)       seg={k:"Champions",  lbl:"Champions",          tone:"acc",  ico:"crown"};
  else if(R<=2&&Mo>=4)        seg={k:"HVAR",       lbl:"High Value At Risk", tone:"neg",  ico:"alert"};
  else if(F>=4&&R>=3)         seg={k:"Loyal",      lbl:"Loyal",              tone:"pos",  ico:"heart"};
  else if(R<=2&&F>=3)         seg={k:"AtRisk",     lbl:"At Risk",            tone:"neg",  ico:"alert"};
  else if(R>=4&&F>=2)         seg={k:"PotLoyal",   lbl:"Potential Loyalist", tone:"pos",  ico:"star"};
  else if(R>=4&&F<=1)         seg={k:"New",        lbl:"New Customer",       tone:"acc",  ico:"user"};
  else if(R>=3&&F<=2)         seg={k:"Promising",  lbl:"Promising",          tone:"acc",  ico:"bolt"};
  else if(R===3&&F===3)       seg={k:"Needs",      lbl:"Needs Attention",    tone:"warn", ico:"eye"};
  else if(R<=1&&F<=2)         seg={k:"Lost",       lbl:"Lost",               tone:"neg",  ico:"swap"};
  else if(R<=2&&F<=2)         seg={k:"Sleep",      lbl:"About to Sleep",     tone:"warn", ico:"clock"};
  else                        seg={k:"Needs",      lbl:"Needs Attention",    tone:"warn", ico:"eye"};
  M.rfm={R:R,F:F,M:Mo,seg:seg,codigo:""+R+F+Mo};
}

/* score 0-100 calibrado nos percentis da base (não em faixas fixas) */
function computeScore(M){
  var f=[], score=0;
  function add(lbl,ico,pts,max,color){ pts=Math.round(clamp(pts,0,max)); score+=pts; f.push({lbl:lbl,ico:ico,pts:pts,max:max,color:color}); }
  var pv=M.hasBase?M.pctl.receita:clamp(M.ltv/2000,0,1);
  var pl=M.hasBase?M.pctl.lucro  :clamp(M.lucro/1000,0,1);
  var pp=M.hasBase?M.pctl.pedidos:clamp(M.n/10,0,1);
  add("Valor (LTV)","money",pv*30,30,"#fff200");
  /* recência relativa ao próprio ciclo, não a um número absoluto */
  var rec = M.diasUltima==null?0:(M.ciclo>0?clamp(1-(M.diasUltima/(M.ciclo*2)),0,1):clamp(1-M.diasUltima/180,0,1));
  add("Recência","clock",rec*20,20,"#48f91e");
  var fr = M.hasBase&&M.avg.freq? clamp(M.freqMes/(M.avg.freq*1.6),0,1) : clamp(M.freqMes/1.5,0,1);
  add("Frequência","repeat",fr*20,20,"#48f91e");
  add("Pedidos","cart",pp*15,15,"#f5a623");
  add("Rentabilidade","chart",pl*15,15,"#fff200");
  M.score=Math.round(clamp(score,0,100));
  M.factors=f;
  M.scoreColor=M.score>=80?"#48f91e":M.score>=60?"#fff200":M.score>=40?"#f5a623":"#ff4d4d";
  M.segmento = M.score>=90?{lbl:"Campeão",color:"#fff200"}
    : M.score>=80?{lbl:"VIP",color:"#48f91e"}
    : M.score>=70?{lbl:"Premium",color:"#48f91e"}
    : M.score>=60?{lbl:"Promissor",color:"#f5a623"}
    : M.score>=40?{lbl:"Comum",color:"#8a8a8a"}
    : {lbl:"Baixo engajamento",color:"#ff4d4d"};
}

/* predições — heurísticas explicáveis, todas ancoradas no ciclo do cliente */
function computePred(M){
  var ratio=M.cicloRatio||0;
  var base = M.n<=1 ? 30 : 78;
  var pRecompra = M.ciclo>0 ? clamp(Math.round(base*(1.25-ratio*0.55)),5,95) : (M.n>1?55:25);
  var pChurn    = M.ciclo>0 ? clamp(Math.round(ratio*42),5,95) : (M.n>1?22:58);
  var p30d      = M.ciclo>0 ? clamp(Math.round(100-Math.abs(M.ciclo-(M.diasUltima||0)+30)/Math.max(M.ciclo,1)*45),5,95) : 28;
  var pVip      = clamp(Math.round(M.score>=70?85:M.score>=50?58:M.score>=35?32:15),5,95);
  M.pred={recompra:pRecompra,churn:pChurn,retencao:100-pChurn,d30:p30d,vip:pVip};
}

/* ==========================================================================
   RENDER
   ========================================================================== */
function render(M){
  var c=M.c;
  var nome=String(c.nome||c.name||c.email||"—");
  document.getElementById("mc-title").textContent=nome;

  var sub=[];
  if(c.email) sub.push('<span class="cid-sub-i">'+ic("mail")+esc(c.email)+'</span>');
  if(c.cidade) sub.push('<span class="cid-sub-i">'+ic("pin")+esc(c.cidade+(c.estado?", "+ufOf(c.estado):""))+(regiaoOf(c.estado)?" · "+regiaoOf(c.estado):"")+'</span>');
  if(c.phone) sub.push('<span class="cid-sub-i">'+ic("phone")+esc(c.phone)+'</span>');
  document.getElementById("mc-sub").innerHTML=sub.join("");

  /* header direito: badges + anel de score */
  var hr='';
  hr+='<span class="cid-badge" style="border-color:'+M.segmento.color+';color:'+M.segmento.color+'">'+ic("star")+esc(M.segmento.lbl)+'</span>';
  if(M.rfm) hr+='<span class="cid-badge" style="border-color:'+toneCor(M.rfm.seg.tone)+';color:'+toneCor(M.rfm.seg.tone)+'"'
    +tipRows("Segmentação RFM",[
      ["Recência","R"+M.rfm.R+" · "+(M.diasUltima!=null?DIAS(M.diasUltima):"—")],
      ["Frequência","F"+M.rfm.F+" · "+NUM(M.n)+" pedidos"],
      ["Valor","M"+M.rfm.M+" · "+BRL(M.ltv)],
      [null],
      ["Código RFM",M.rfm.codigo,"hl"]
    ],rfmExplica(M))+'>'+ic(M.rfm.seg.ico)+esc(M.rfm.seg.lbl)+'</span>';
  hr+='<div class="cid-score-wrap"><div class="cid-score-ring-wrap"'
    +tipRows("Score do cliente",M.factors.map(function(f){ return [f.lbl,f.pts+"/"+f.max]; }).concat([[null],["Total",M.score+"/100","hl"]]),
      "Calibrado nos percentis reais da base, não em faixas fixas.")+'>'
    +scoreRing(M.score,80,M.scoreColor)
    +'<div class="cid-score-ring-val"><span class="cid-score-num" style="color:'+M.scoreColor+'">'+M.score+'</span><span class="cid-score-seg">score</span></div>'
    +'</div></div>';
  document.getElementById("mc-head-right").innerHTML=hr;

  var html="";
  html+=kpiRow(M);
  html+=alertas(M);
  html+=heroRow(M);
  html+=evolucaoStack(M);
  html+=insightsGerais(M);
  html+=duoProdutoPreco(M);
  html+=duoCanalTempo(M);
  html+=comparaBase(M);
  html+=painelDevolucoes(M);
  html+=historico(M);

  var wrap=document.getElementById("mc-client-wrap");
  wrap.innerHTML=html+aiPanel(M);

  /* pós-render: barras crescem e números embaralham */
  requestAnimationFrame(function(){
    Array.prototype.forEach.call(wrap.querySelectorAll(".cid-bar-fill,.cid-factor-fill,.cid-src-fill,.cx2-fill"),function(b){
      if(b.hasAttribute("data-left")) b.style.left=b.getAttribute("data-left")+"%";
      b.style.width=(b.getAttribute("data-w")||0)+"%";
    });
    Array.prototype.forEach.call(wrap.querySelectorAll(".cid-vcol-fill"),function(b){ b.style.height=(b.getAttribute("data-h")||0)+"%"; });
    Array.prototype.forEach.call(wrap.querySelectorAll("[data-to]"),scrambleVal);
  });
  Array.prototype.forEach.call(wrap.querySelectorAll("[data-oid]"),function(tr){
    tr.addEventListener("click",function(ev){
      if(ev.target.closest("a")) return;
      var oid=tr.getAttribute("data-oid"); if(oid) window.location.href=PAGE_PEDIDO+"?id="+encodeURIComponent(oid);
    });
  });
  wireAiDrawer(wrap);
  wireTips();
}
function toneCor(t){ return t==="pos"?"#48f91e":t==="neg"?"#ff4d4d":t==="warn"?"#f5a623":"#fff200"; }
function rfmExplica(M){
  if(!M.rfm) return "";
  var p=[];
  if(M.hasBase) p.push("Entre os "+Math.round((1-M.pctl.receita)*100+1)+"% de maior valor e "+Math.round((1-M.pctl.pedidos)*100+1)+"% de maior frequência.");
  if(M.ciclo>0&&M.cicloRatio>1.3) p.push("Está "+M.cicloRatio.toFixed(1)+"× acima do intervalo normal entre compras.");
  return p.join(" ");
}

/* ---------------------------- KPI strip ---------------------------- */
function kpiRow(M){
  var h='<div class="cid-kpi-row">';
  h+=kpi("LTV","money",M.ltv,"brl","acc","lifetime",
    tipRows("LTV — valor de vida",[
      ["Receita bruta",BRL(M.ltv)],
      ["Descontos concedidos",BRL(M.desconto),"bad"],
      ["Custo dos produtos",BRL(M.cogs),"bad"],
      ["Frete absorvido",BRL(M.fretePago),"bad"],
      ["Taxas de gateway",BRL(M.taxa),"bad"],
      [null],
      ["Lucro acumulado",BRL(M.lucro),M.lucro>=0?"good":"bad"],
      M.hasBase?["LTV médio da base",BRL(M.avg.ltv)]:null,
      M.hasBase?["Posição","#"+NUM(M.rank.receita)+" de "+NUM(M.total),"hl"]:null
    ],M.hasBase?("Top "+Math.max(1,Math.round((1-M.pctl.receita)*100))+"% da base por receita."):""));
  h+=kpi("Lucro acumulado","chart",M.lucro,"brl",M.lucro>=0?"good":"bad",PCT(M.margem)+" de margem",
    tipRows("Lucro real",[
      ["Receita",BRL(M.ltv)],
      ["Custo total",BRL(M.custo),"bad"],
      [null],
      ["Lucro bruto",BRL(M.lucro),"good"],
      ["Custo de devoluções",BRL(M.custoDevLog),"bad"],
      ["Lucro líquido",BRL(M.lucroLiquido),M.lucroLiquido>=0?"good":"bad"],
      [null],
      ["Lucro por pedido",BRL(M.lucroPed)],
      M.hasBase?["Lucro médio da base",BRL(M.avg.lucro)]:null
    ]));
  h+=kpi("Pedidos","cart",M.n,"num","",M.nCancelados?(M.nCancelados+" cancelado"+(M.nCancelados>1?"s":"")):"válidos",
    tipRows("Pedidos",[
      ["Pedidos pagos",NUM(M.n)],
      M.nCancelados?["Cancelados / devolvidos",NUM(M.nCancelados),"bad"]:null,
      ["Itens comprados",NUM(M.itensQtd)],
      ["Itens por pedido",M.itensPed.toFixed(1)],
      ["Produtos distintos",NUM(M.produtos.length)],
      M.hasBase?[null]:null,
      M.hasBase?["Média da base",M.avg.pedidos.toFixed(1)+" pedidos"]:null,
      M.hasBase?["Posição","#"+NUM(M.rank.pedidos)+" de "+NUM(M.total),"hl"]:null
    ]));
  h+=kpi("Ticket médio","compare",M.ticket,"brl","",M.n?("em "+NUM(M.n)+" pedidos"):"",
    tipRows("Ticket médio",[
      ["Primeiro pedido",BRL(M.ticketPrimeiro)],
      ["Último pedido",BRL(M.ticketUltimo)],
      ["Média 3 primeiros",BRL(M.media3Primeiros)],
      ["Média 3 últimos",BRL(M.media3Ultimos)],
      [null],
      ["Tendência",(M.tendTicket>=0?"+":"")+Math.round(M.tendTicket*100)+"%",M.tendTicket>=0?"good":"bad"],
      M.hasBase?["Ticket médio da base",BRL(M.avg.ticket)]:null,
      M.hasBase?["Posição","#"+NUM(M.rank.ticket)+" de "+NUM(M.total),"hl"]:null
    ]));
  h+=kpi("Margem média","gauge",M.margem,"pct",M.margem>=0.35?"good":M.margem>=0.15?"warn":"bad","por pedido",
    tipRows("Margem",[
      ["Receita",BRL(M.ltv)],
      ["CMV",BRL(M.cogs),"bad"],
      ["Descontos",BRL(M.desconto),"bad"],
      ["Frete absorvido",BRL(M.fretePago),"bad"],
      ["Taxas",BRL(M.taxa),"bad"],
      [null],
      ["Margem",PCT(M.margem),M.margem>=0.3?"good":"bad"],
      M.hasBase?["Margem média da base",PCT(M.avg.margem)]:null
    ]));
  if(M.ciclo)
    h+=kpi("Ciclo de recompra","repeat",M.ciclo,"dias","","mediana entre pedidos",
      tipRows("Intervalo entre compras",[
        ["Mediana",DIAS(M.gapMediana)],
        ["Média",DIAS(Math.round(M.gapMedio))],
        ["Mais curto",DIAS(M.gapMin)],
        ["Mais longo",DIAS(M.gapMax)],
        ["1ª → 2ª compra",M.gap1a2?DIAS(M.gap1a2):"—"],
        [null],
        ["Janela provável",M.janelaIni+"–"+M.janelaFim+" dias","hl"],
        M.intervals&&M.intervals.p50?["Mediana da base",DIAS(M.intervals.p50)]:null
      ]));
  if(M.diasUltima!=null)
    h+=kpi("Última compra","clock",M.diasUltima,"dias",
      M.cicloRatio>2?"bad":M.cicloRatio>1.3?"warn":"good","atrás",
      tipRows("Recência",[
        ["Data",DATE(M.ultima)],
        ["Dias desde então",DIAS(M.diasUltima)],
        M.ciclo?["Ciclo normal",DIAS(M.ciclo)]:null,
        M.ciclo?["Posição no ciclo",M.cicloRatio.toFixed(1)+"×",M.cicloRatio>1.3?"bad":"good"]:null,
        [null],
        ["Primeira compra",DATE(M.primeira)],
        ["Tempo como cliente",M.mesesCliente+" meses"]
      ],M.ciclo&&M.cicloRatio>1.3?("Já passou "+Math.round((M.cicloRatio-1)*100)+"% do intervalo habitual."):""));
  h+=kpi("Status","user",0,"num",M.n>1?"good":"warn",null,
    tipRows("Situação",[
      ["Tipo",M.n>1?"Recorrente":"Compra única"],
      ["Reativações",NUM(M.reativacoes)],
      M.rfm?["Segmento RFM",M.rfm.seg.lbl,"hl"]:null,
      ["Probabilidade de recompra",M.pred.recompra+"%"],
      ["Risco de churn",M.pred.churn+"%",M.pred.churn>60?"bad":"good"]
    ]),M.n>1?"Recorrente":"Novo");
  return h+'</div>';
}
function kpi(lbl,icon,val,fmt,cls,sub,tipAttr,textoFixo){
  var disp = textoFixo!=null ? esc(textoFixo)
    : '<span class="cid-kpi-val '+(cls||"")+'" data-to="'+val+'" data-fmt="'+fmt+'">'+(fmt==="brl"?BRL(0):fmt==="pct"?PCT(0):"0")+'</span>';
  if(textoFixo!=null) disp='<span class="cid-kpi-val '+(cls||"")+'">'+disp+'</span>';
  /* só o LTV leva o tracinho amarelo — é a métrica que resume a página */
  return '<div class="cid-kpi'+(lbl==="LTV"?" is-key":"")+'"'+(tipAttr||"")+'>'
    +'<span class="cid-kpi-lbl">'+ic(icon)+lbl+'</span>'+disp
    +(sub?'<span class="cid-kpi-sub">'+esc(sub)+'</span>':'')+'</div>';
}

/* ---------------------------- alertas ---------------------------- */
function alertas(M){
  var out=[];
  if(M.diasUltima!=null && M.ciclo>0 && M.cicloRatio>=2.2)
    out.push({t:"critical",ico:"alert",b:"Risco de churn elevado",
      x:"há "+DIAS(M.diasUltima)+" sem comprar, contra um ciclo normal de "+DIAS(M.ciclo)+" ("+M.cicloRatio.toFixed(1)+"× o intervalo habitual)."});
  else if(M.diasUltima!=null && M.ciclo>0 && M.cicloRatio>=1.35)
    out.push({t:"",ico:"clock",b:"Atrasado para recomprar",
      x:"está no dia "+M.diasUltima+" de um ciclo que costuma fechar em "+M.ciclo+" — janela de reativação aberta."});
  else if(M.ciclo>0 && M.diasUltima!=null && M.diasUltima>=M.janelaIni && M.diasUltima<=M.janelaFim)
    out.push({t:"positive",ico:"target",b:"Janela de recompra aberta",
      x:"costuma voltar entre "+M.janelaIni+" e "+M.janelaFim+" dias e está no dia "+M.diasUltima+" — melhor momento para acionar."});
  if(M.n===1)
    out.push({t:"",ico:"user",b:"Apenas 1 compra",
      x:"a segunda compra é o degrau de maior impacto no LTV — prioridade para ação de recompra."});
  if(M.devTotal>=2 && M.taxaDev>0.3)
    out.push({t:"critical",ico:"swap",b:"Custo operacional alto",
      x:NUM(M.devTotal)+" devoluções/trocas em "+NUM(M.n)+" pedidos ("+PCT0(M.taxaDev)+") — "+BRL(M.custoDevLog)+" de custo logístico."});
  if(!out.length) return "";
  return out.map(function(a){
    return '<div class="cid-alert '+a.t+'"><span class="cid-alert-ico">'+ic(a.ico)+'</span>'
      +'<span class="cid-alert-txt"><b>'+esc(a.b)+'</b>: '+esc(a.x)+'</span></div>';
  }).join("")+'<div style="height:8px"></div>';
}

/* ---------------------------- hero ---------------------------- */
function heroRow(M){
  return '<div class="cid-hero">'+perfilPanel(M)
    +'<div class="cid-hero-side">'+financeiroPanel(M)+scorePanel(M)+'</div></div>';
}
function perfilPanel(M){
  var c=M.c, r=[];
  r.push(row2("mail","Email",esc(c.email||"—")));
  r.push(row2("phone","Telefone",esc(c.phone||"—")));
  r.push(row2("pin","Cidade",esc(c.cidade?(c.cidade+(c.estado?", "+ufOf(c.estado):"")):"—")));
  var rg=regiaoOf(c.estado);
  if(rg){
    var rs=M.regiaoStats;   /* só existe depois que customer_base responde */
    r.push(row2("route","Região",esc(rg)+(rs&&rs.n?' <small>· '+NUM(rs.n)+' clientes</small>':""),"",
      rs&&rs.n?tipRows("Região "+rg,[
        ["Clientes na região",NUM(rs.n)],
        ["Ticket médio da região",BRL(rs.ticket)],
        ["Este cliente",BRL(M.ticket),M.ticket>=rs.ticket?"good":"bad"],
        [null],
        ["LTV médio da região",BRL(rs.ltv)],
        ["Este cliente",BRL(M.ltv),M.ltv>=rs.ltv?"good":"bad"]
      ]):""));
  }
  if(M.cidadeStats&&M.cidadeStats.n>1)
    r.push(row2("trophy","Posição na cidade","#"+NUM(M.cidadeStats.rank)+" <small>de "+NUM(M.cidadeStats.n)+"</small>","acc",
      tipRows("Ranking em "+String(c.cidade||""),[
        ["Clientes na cidade",NUM(M.cidadeStats.n)],
        ["Posição por receita","#"+NUM(M.cidadeStats.rank)],
        ["Top",PCT0(M.cidadeStats.rank/M.cidadeStats.n)+" da cidade","hl"],
        [null],
        ["Ticket médio local",BRL(M.cidadeStats.ticket)],
        ["Este cliente",BRL(M.ticket),M.ticket>=M.cidadeStats.ticket?"good":"bad"]
      ])));
  /* aniversário: só aparece se o dado existir de verdade */
  if(M.aniversario){
    var a=M.aniversario;
    var tone=a.dias<=15?"acc":"";
    r.push(row2("cake","Nascimento",esc(a.data)+' <small>· '+a.idade+' anos</small>'));
    r.push(row2("target","Aniversário",
      (a.dias===0?"hoje":"em "+DIAS(a.dias))+' <small>· '+esc(a.dia)+'</small>',tone,
      tipRows("Aniversário",[
        ["Data",a.data],["Idade atual",a.idade+" anos"],
        ["Faltam",a.dias===0?"é hoje":DIAS(a.dias),"hl"]
      ],a.dias<=30?"Janela boa para uma ação personalizada.":"")));
  }
  r.push(row2("calendar","Primeira compra",DATE(M.primeira)));
  r.push(row2("clock","Tempo como cliente",M.mesesCliente?(M.mesesCliente+" meses"):"—"));
  r.push(row2("route","Canal de aquisição",esc(M.canalPrimeiro||"—"),"",
    tipRows("Aquisição",[
      ["Canal da 1ª compra",M.canalPrimeiro||"—"],
      ["Canal do último pedido",M.canalUltimo||"—"],
      M.campanhaPrimeira?["Campanha de entrada",M.campanhaPrimeira]:null,
      M.anuncioPrimeiro?["Anúncio",M.anuncioPrimeiro]:null,
      M.cupomPrimeiro?["Cupom da 1ª compra",M.cupomPrimeiro]:null,
      [null],
      ["Produto de entrada",M.primeiroProduto||"—","hl"]
    ])));
  if(M.campanhaPrimeira) r.push(row2("target","Campanha de entrada",esc(M.campanhaPrimeira)));
  if(M.primeiroProduto) r.push(row2("box","Produto de entrada",esc(M.primeiroProduto),"",
    M.coorte&&M.coorte.produto?tipRows("Quem entra por este produto",[
      ["Clientes",NUM(M.coorte.produto.n)],
      ["LTV médio",BRL(M.coorte.produto.ltv)],
      ["Taxa de recompra",PCT0(M.coorte.produto.rec)],
      [null],
      ["Este cliente",BRL(M.ltv),M.ltv>=M.coorte.produto.ltv?"good":"bad"]
    ]):""));
  if(M.cupomPrimeiro) r.push(row2("tag","Cupom da 1ª compra",esc(M.cupomPrimeiro),"warn"));
  return '<div class="cid-panel grow"><div class="cid-panel-head"><h2>'+ic("user")+'Perfil</h2>'
    +(M.rfm?'<span class="cid-tag">RFM '+M.rfm.codigo+'</span>':'')+'</div>'
    +'<div class="cid-panel-body"><div class="cid-grid2">'+r.join("")+'</div></div></div>';
}
function row2(icon,lbl,val,cls,tipAttr){
  return '<div class="cid-row"'+(tipAttr||"")+'><span class="cid-row-lbl">'+(icon?ic(icon):"")+lbl+'</span>'
    +'<span class="cid-row-val'+(cls?" "+cls:"")+'">'+val+'</span></div>';
}
function financeiroPanel(M){
  var g='<div class="cid-fin-grid">'
    +stat("LTV","money",BRL(M.ltv),"acc",M.ltv,"brl")
    +stat("Lucro","chart",BRL(M.lucro),M.lucro>=0?"good":"bad",M.lucro,"brl")
    +stat("Margem","gauge",PCT(M.margem),M.margem>=0.3?"good":M.margem>=0.15?"warn":"bad",M.margem,"pct")
    +stat("Ticket","compare",BRL(M.ticket),"",M.ticket,"brl")
    +stat("Desconto médio","tag",BRL(M.descontoMedio),M.pctComDesconto>0.6?"warn":"",M.descontoMedio,"brl")
    +stat("Frete médio","truck",BRL(M.freteMed),"",M.freteMed,"brl")
    +stat("Itens / pedido","box",M.itensPed.toFixed(1),"",0,"num",true)
    +stat("Preço médio/item","list",BRL(M.precoMedioItem),"",M.precoMedioItem,"brl")
    +'</div>';
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("money")+'Análise financeira</h2>'
    +'<span class="cid-tag">'+NUM(M.n)+' pedidos</span></div>'
    +'<div class="cid-panel-body" style="padding:0">'+g+'</div></div>';
}
function stat(lbl,icon,disp,cls,raw,fmt,fixo){
  var attr = fixo ? "" : ' data-to="'+raw+'" data-fmt="'+fmt+'"';
  return '<div class="cid-stat">'
    +'<span class="cid-stat-lbl"><span class="cid-stat-ic">'+ic(icon)+'</span>'+lbl+'</span>'
    +'<span class="cid-stat-val '+(cls||"")+'"'+attr+'>'+disp+'</span></div>';
}
function scorePanel(M){
  var f=M.factors.map(function(x){
    var pct=x.max?x.pts/x.max:0;
    return '<div class="cid-factor"'+tipRows(x.lbl,[
        ["Pontos",x.pts+" de "+x.max],
        ["Aproveitamento",PCT0(pct)]
      ],fatorNota(x.lbl,M))+'>'
      +'<span class="cid-factor-lbl">'+ic(x.ico)+x.lbl+'</span>'
      +'<div class="cid-factor-bar"><div class="cid-factor-fill" data-w="'+(pct*100).toFixed(0)+'"'
      +' style="background:'+(pct>=0.8?"var(--acc)":"rgba(255,255,255,.22)")+'"></div></div>'
      +'<span class="cid-factor-val">'+x.pts+'/'+x.max+'</span></div>';
  }).join("");
  return '<div class="cid-panel grow"><div class="cid-panel-head"><h2>'+ic("trophy")+'Composição do score</h2>'
    +'<span class="cid-tag acc">'+M.score+'/100</span></div>'
    +'<div class="cid-panel-body">'+f+'</div></div>';
}
function fatorNota(lbl,M){
  if(lbl==="Valor (LTV)"&&M.hasBase) return "Percentil "+Math.round(M.pctl.receita*100)+" da base por receita.";
  if(lbl==="Recência") return M.ciclo?("Ciclo normal de "+DIAS(M.ciclo)+"; está no dia "+(M.diasUltima||0)+"."):"";
  if(lbl==="Frequência"&&M.hasBase) return "Média da base: "+M.avg.freq.toFixed(2)+" pedidos/mês.";
  if(lbl==="Pedidos"&&M.hasBase) return "Média da base: "+M.avg.pedidos.toFixed(1)+" pedidos.";
  if(lbl==="Rentabilidade"&&M.hasBase) return "Lucro médio da base: "+BRL(M.avg.lucro)+".";
  return "";
}

/* ------------------- evolução + recorrência (soldados) ------------------- */
function evolucaoStack(M){
  return '<div class="cid-stack">'+evolucaoPanel(M)+recorrenciaPanel(M)+'</div>';
}
function evolucaoPanel(M){
  var asc=M.asc.slice(-24);
  if(asc.length<2){
    return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("chart")+'Evolução do cliente</h2>'
      +'<span class="cid-tag">1 pedido</span></div>'
      +'<div class="cid-panel-body"><p class="cid-note">Só há um pedido — a curva de evolução aparece a partir da segunda compra.</p></div></div>';
  }
  var max=0, acc=0, pontos=[];
  asc.forEach(function(o){ max=Math.max(max,nz(o.faturamento)); });
  max=max||1;
  var total=asc.reduce(function(s,o){ return s+nz(o.faturamento); },0)||1;
  var cols=asc.map(function(o,i){
    var v=nz(o.faturamento), h=clamp(v/max*100,3,100);
    acc+=v; pontos.push(acc/total);
    var isTop=v===max;
    var itens=M.its.filter(function(it){ return String(it.order_id)===String(o.id); });
    var rows=[
      ["Data",DATE(o.created_at)],
      ["Pedido","#"+String(o.order_number||o.id)],
      ["Valor",BRL(v),"hl"],
      ["Lucro",BRL(nz(o.lucro)),nz(o.lucro)>=0?"good":"bad"],
      ["Margem",PCT(nz(o.margem))],
      ["Itens",NUM(nz(o.itens_qtd)||itens.length)],
      [null],
      ["LTV acumulado",BRL(acc),"hl"]
    ];
    if(i>0){
      var g=Math.round((new Date(o.created_at)-new Date(asc[i-1].created_at))/86400000);
      rows.splice(6,0,["Desde o anterior",DIAS(g),M.ciclo&&g>M.ciclo*1.3?"bad":""]);
    }
    return '<div class="cid-vcol'+(isTop?" is-top":"")+'"'+tipRows("Pedido "+(i+1),rows)+'>'
      +'<span class="cid-vcol-val">'+kBRL(v)+'</span>'
      +'<div class="cid-vcol-track"><div class="cid-vcol-fill" data-h="'+h.toFixed(1)+'"></div></div>'
      +'<span class="cid-vcol-lbl">#'+(i+1)+'</span>'
      +'<span class="cid-vcol-un">'+DATE(o.created_at).slice(0,5)+'</span></div>';
  }).join("");
  /* curva de LTV acumulado por cima das colunas */
  var pts=pontos.map(function(p,i){
    var x=pontos.length>1?(i/(pontos.length-1))*100:50;
    return x.toFixed(2)+","+((1-p)*100).toFixed(2);
  });
  var spark='<svg class="cid-spark" viewBox="0 0 100 100" preserveAspectRatio="none">'
    +'<path vector-effect="non-scaling-stroke" d="M'+pts.join(" L")+'"/>'
    +'<circle cx="'+pts[pts.length-1].split(",")[0]+'" cy="'+pts[pts.length-1].split(",")[1]+'" r="2" vector-effect="non-scaling-stroke"/></svg>';
  var tend=M.tendTicket;
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("chart")+'Evolução do cliente</h2>'
    +'<span class="cid-tag '+(tend>=0?"good":"bad")+'"'+tipRows("Tendência de gasto",[
      ["Média 3 primeiros",BRL(M.media3Primeiros)],
      ["Média 3 últimos",BRL(M.media3Ultimos)],
      [null],
      ["Variação",(tend>=0?"+":"")+Math.round(tend*100)+"%",tend>=0?"good":"bad"],
      ["Primeiro pedido",BRL(M.ticketPrimeiro)],
      ["Último pedido",BRL(M.ticketUltimo)]
    ],"A linha verde é o LTV acumulado ao longo dos pedidos.")+'>'
    +(tend>=0?"+":"")+Math.round(tend*100)+'% no ticket</span></div>'
    +'<div class="cid-panel-body" style="padding:14px 15px 8px"><div class="cid-vchart"><div class="cid-vcols">'+cols+'</div>'+spark+'</div></div></div>';
}
function recorrenciaPanel(M){
  var body='';
  if(M.ciclo>0){
    var pos=clamp((M.diasUltima||0)/Math.max(M.gapMax||M.ciclo*2,1)*100,0,100);
    body+='<div class="cid-bar-row'+(M.cicloRatio<=1.2?" is-top":"")+'"'+tipRows("Onde está no ciclo",[
        ["Ciclo mediano",DIAS(M.ciclo)],
        ["Dias desde a última",DIAS(M.diasUltima||0)],
        ["Posição no ciclo",M.cicloRatio.toFixed(2)+"×",M.cicloRatio>1.3?"bad":"good"],
        [null],
        ["Janela provável",M.janelaIni+"–"+M.janelaFim+" dias","hl"]
      ])+'>'
      +'<span class="cid-bar-lbl">Ciclo atual</span>'
      +'<div class="cid-bar-track"><div class="cid-bar-fill" data-w="'+pos.toFixed(0)+'"></div></div>'
      +'<span class="cid-bar-val">'+M.cicloRatio.toFixed(1)+'×</span></div>';
  }
  var rows=[
    ["repeat","Intervalo mediano",M.ciclo?DIAS(M.ciclo):"—",""],
    ["clock","Intervalo médio",M.gapMedio?DIAS(Math.round(M.gapMedio)):"—",""],
    ["bolt","Mais curto / mais longo",M.gaps.length?(M.gapMin+" / "+M.gapMax+" dias"):"—",""],
    ["arrow","1ª → 2ª compra",M.gap1a2?DIAS(M.gap1a2):"—",""],
    ["swap","Reativações",NUM(M.reativacoes),M.reativacoes?"warn":""],
    ["target","Janela de recompra",M.ciclo?(M.janelaIni+"–"+M.janelaFim+" dias"):"—","acc"]
  ];
  if(M.tendCiclo) rows.push(["gauge","Tendência do ciclo",
    (M.tendCiclo<0?"acelerando ":"desacelerando ")+Math.abs(Math.round(M.tendCiclo*100))+"%",
    M.tendCiclo<0?"good":"warn"]);
  body+='<div class="cid-grid2">'+rows.map(function(r){ return row2(r[0],r[1],r[2],r[3]); }).join("")+'</div>';
  var preds='<div class="cid-preds" style="margin-top:12px">'
    +pred(M.pred.recompra,"Recompra","#48f91e",tipRows("Probabilidade de recompra",[
        ["Ciclo normal",M.ciclo?DIAS(M.ciclo):"—"],
        ["Dias desde a última",DIAS(M.diasUltima||0)],
        ["Pedidos no histórico",NUM(M.n)]
      ],"Cai conforme o cliente ultrapassa o próprio ciclo."))
    +pred(M.pred.retencao,"Retenção",M.pred.churn<40?"#48f91e":M.pred.churn<65?"#f5a623":"#ff4d4d",
      tipRows("Retenção",[["Risco de churn",M.pred.churn+"%",M.pred.churn>60?"bad":"good"],["Retenção",M.pred.retencao+"%"]]))
    +pred(M.pred.d30,"Compra 30d","#fff200",tipRows("Compra nos próximos 30 dias",[
        ["Janela provável",M.ciclo?(M.janelaIni+"–"+M.janelaFim+" dias"):"—"],
        ["Está no dia",String(M.diasUltima||0)]
      ]))
    +pred(M.pred.vip,"Potencial VIP","#fff200",tipRows("Potencial VIP",[
        ["Score atual",M.score+"/100"],
        M.hasBase?["Percentil de receita",Math.round(M.pctl.receita*100)+"º"]:null,
        M.hasBase?["LTV esperado do perfil",BRL(M.ltvEsperado)]:null
      ]))
    +'</div>';
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("repeat")+'Recorrência e ciclo</h2>'
    +'<span class="cid-tag'+(M.cicloRatio>1.3?" warn":"")+'">'+(M.ciclo?(M.cicloRatio.toFixed(1)+"× do ciclo"):"sem ciclo")+'</span></div>'
    +'<div class="cid-panel-body">'+body+preds+'</div></div>';
}
function pred(score,label,color,tipAttr){
  return '<div class="cid-pred"'+(tipAttr||"")+'><div class="cid-pred-ring">'+scoreRing(score,52,color)
    +'<div class="cid-pred-ring-val">'+score+'</div></div><div class="cid-pred-lbl">'+label+'</div></div>';
}

/* ---------------------------- insights gerais ---------------------------- */
function insightsGerais(M){
  var cells=[];
  /* val já vem escapado pelos chamadores — aqui não se re-escapa, porque
     valorPref/selo devolvem marcação */
  function gi(lbl,val,icon,tipAttr,selo){
    return '<div class="cid-gi"'+(tipAttr||"")+'><span class="cid-gi-ic">'+ic(icon||"info")+'</span>'
      +'<div class="cid-gi-tx"><div class="cid-gi-lbl">'+lbl+'</div>'
      +'<div class="cid-gi-val">'+val+'</div>'
      +(selo?'<div class="cid-gi-sel">'+selo+'</div>':'')+'</div></div>';
  }
  /* card de preferência: passa pelo teste de significância antes de nomear
     um vencedor. Com 1 preto e 1 branco não há favorita, há empate. */
  function giPref(lbl,lista,total,icon,titulo,unid,extras){
    var pref=preferencia(lista,total); pref.lista=lista;
    var rc=racional(pref,titulo.toLowerCase());
    var dist=(lista||[]).slice(0,5).map(function(x){
      return ["· "+esc(String(x.k)),NUM(x.n)+" "+unid+" ("+PCT0(total?x.n/total:0)+")"]; });
    return gi(lbl,valorPref(pref),icon,
      tipRows(titulo,dist.concat([[null]],rc.linhas,extras||[]),rc.nota),selo(pref));
  }

  /* dia da semana: 7 opções, então o acaso é 1/7 — exige bem mais evidência */
  var listaWD=WD.map(function(d,i){ return {k:d,n:M.wd[i]}; })
    .filter(function(x){ return x.n>0; }).sort(function(a,b){ return b.n-a.n; });
  cells.push(giPref("Dia dominante",listaWD,M.n,"calendar","Pedidos por dia da semana","ped",
    [["Fim de semana",NUM(M.fimDeSemana)],["Dias úteis",NUM(M.diasUteis)]]));

  /* horário: agrupado em 4 faixas de propósito — hora cheia com 6 pedidos
     é ruído garantido (24 categorias para n minúsculo) */
  var listaFx=[["Madrugada",0,5],["Manhã",6,11],["Tarde",12,17],["Noite",18,23]]
    .map(function(f){ var s=0; for(var h=f[1];h<=f[2];h++) s+=M.hr[h]; return {k:f[0],n:s}; })
    .filter(function(x){ return x.n>0; }).sort(function(a,b){ return b.n-a.n; });
  cells.push(giPref("Faixa horária",listaFx,M.n,"clock","Pedidos por faixa horária","ped",
    [["Pico bruto",M.n?M.bestHr+"h":"—"],
     ["Ressalva","hora cheia tem 24 categorias"]]));

  cells.push(giPref("Categoria dominante",M.categorias,M.unidades,"layers","Categorias compradas","un",
    [["Concentração no topo",PCT0(M.concentracaoCat)]]));
  cells.push(giPref("Tamanho dominante",M.tamanhos,M.unidades,"ruler","Tamanhos comprados","un",
    M.tamDevTop?[["Mais devolvido",M.tamDevTop+" ("+M.tamDevTopN+"×)","bad"]]:[]));
  cells.push(giPref("Estampa dominante",M.cores,M.unidades,"palette","Estampas compradas","un",[]));
  cells.push(giPref("Produto dominante",M.produtos.map(function(p){ return {k:p.nome,n:p.n}; }),
    M.unidades,"trophy","Produtos comprados","un",
    [["Produtos distintos",NUM(M.produtos.length)],["SKUs recomprados",NUM(M.recompraSku)]]));
  cells.push(giPref("Canal dominante",M.canais.map(function(x){ return {k:x.canal,n:x.pedidos}; }),
    M.n,"route","Canais de origem","ped",
    [["Primeiro toque",M.canalPrimeiro],["Último toque",M.canalUltimo]]));
  cells.push(giPref("Pagamento",Object.keys(M.pagamentos).map(function(k){ return {k:k,n:M.pagamentos[k]}; })
    .sort(function(a,b){ return b.n-a.n; }),M.n,"money","Formas de pagamento","ped",[]));
  if(M.colecoes.length)
    cells.push(giPref("Drop dominante",M.colecoes,M.unidades,"layers","Coleções / drops","un",
      [["Drops distintos",NUM(M.colecoes.length)]]));

  /* daqui pra baixo são medidas diretas, não inferências — sem selo */
  cells.push(gi("Preço médio/item",BRL(M.precoMedioItem),"tag",
    tipRows("Preço por item",[
      ["Itens considerados",NUM(M.unidades)],
      ["Pago em média",BRL(M.precoMedioItem)],
      ["Preço cheio de catálogo",BRL(M.precoCheioMedio)],
      ["Desconto implícito",PCT(M.descontoImplicito)],
      [null],
      ["Faixa mais frequente",M.faixaPreco]
    ],"Medida direta: soma dos itens dividida pela quantidade. Não é inferência, não tem intervalo.")));
  cells.push(gi("Pedidos com cupom",PCT0(M.pctComCupom),"tag",
    (function(){
      var v=M.storeAvg&&M.storeAvg.pct_com_cupom;
      var t=(v!=null)?vsBase(Math.round(M.pctComCupom*M.n),M.n,v):null;
      return tipRows("Uso de cupom",[
        ["Pedidos com cupom",NUM(Math.round(M.pctComCupom*M.n))+" de "+NUM(M.n)],
        t?["Intervalo 95%",ciTxt(t.w),"hl"]:null,
        v!=null?["Base da loja",PCT0(v)]:null,
        t?[null]:null,
        t?["Veredito",t.signif?(t.acima?"acima da base":"abaixo da base"):"não distinguível",t.signif?"good":""]:null,
        [null],
        ["Cupons distintos",NUM(M.cupons.length)],
        ["Mais usado",M.cupomTop||"nenhum"],
        ["Maior desconto",BRL(M.maiorDesconto)]
      ],t&&!t.signif?"O intervalo cruza a taxa da loja: com "+M.n+" pedidos não dá para dizer que este cliente é mais (ou menos) sensível a cupom que a média.":"");
    })()));
  cells.push(gi("Frete grátis",M.n?PCT0(M.pctFreteGratis):"—","truck",
    (function(){
      var v=M.storeAvg&&M.storeAvg.pct_frete_gratis;
      var t=(v!=null)?vsBase(Math.round(M.pctFreteGratis*M.n),M.n,v):null;
      return tipRows("Frete",[
        ["Pedidos com frete grátis",NUM(Math.round(M.pctFreteGratis*M.n))+" de "+NUM(M.n)],
        t?["Intervalo 95%",ciTxt(t.w),"hl"]:null,
        v!=null?["Base da loja",PCT0(v)]:null,
        [null],
        ["Frete médio pago",BRL(M.freteMed)],
        ["Custo real",BRL(M.freteReal)],
        ["Absorvido pela loja",BRL(M.fretePago)]
      ],t&&!t.signif?"Não distinguível da base — não sustenta a leitura de que ele monta carrinho para bater o frete grátis.":"");
    })()));
  cells=cells.slice(0,12);
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("info")+'Insights gerais</h2>'
    +'<span class="cid-tag">'+cells.length+' métricas</span></div>'
    +'<div class="cid-panel-body" style="padding:0"><div class="cid-gi-grid">'+cells.join("")+'</div></div></div>';
}

/* ---------------------------- 2col: produto | preço ---------------------------- */
function duoProdutoPreco(M){
  return '<div class="cid-2col">'+afinidadePanel(M)+precoPanel(M)+'</div>';
}
function barras(list,total,fmtVal){
  if(!list.length) return '<p class="cid-note">Sem dados de itens para este cliente.</p>';
  var max=list[0].n||1;
  return list.slice(0,7).map(function(x,i){
    return '<div class="cid-bar-row'+(i===0?" is-top":"")+'"'+tipRows(String(x.k||x.nome||""),[
        ["Unidades",NUM(x.n)],
        ["Receita",BRL(x.rec)],
        ["Pedidos",NUM(x.nPedidos)],
        [null],
        ["Participação",PCT0(total?x.n/total:0),"hl"]
      ])+'>'
      +'<span class="cid-bar-lbl">'+esc(String(x.k||x.nome||"—"))+'</span>'
      +'<div class="cid-bar-track"><div class="cid-bar-fill" data-w="'+((x.n/max)*100).toFixed(0)+'"></div></div>'
      +'<span class="cid-bar-val">'+(fmtVal?fmtVal(x):NUM(x.n)+" un")+'</span></div>';
  }).join("");
}
function afinidadePanel(M){
  var body='';
  if(!M.its.length){
    body='<p class="cid-note">Os itens dos pedidos ainda não sincronizaram para este cliente.</p>';
  } else {
    body+='<div style="font-size:9px;text-transform:uppercase;letter-spacing:.08em;color:var(--mut);margin-bottom:6px">Categorias</div>';
    body+=barras(M.categorias,M.unidades);
    body+='<div style="font-size:9px;text-transform:uppercase;letter-spacing:.08em;color:var(--mut);margin:14px 0 6px">Tamanhos</div>';
    body+=barras(M.tamanhos,M.unidades);
    body+='<div style="font-size:9px;text-transform:uppercase;letter-spacing:.08em;color:var(--mut);margin:14px 0 6px">Produtos</div>';
    body+=barras(M.produtos.map(function(p){ return {k:p.nome,n:p.n,rec:p.rec,nPedidos:p.nPedidos}; }),M.unidades,
      function(x){ return kBRL(x.rec); });
    if(M.proximaCat){
      var pc=M.proximaCat;
      var vale=pc.signif;
      body+='<div class="cid-row" style="margin-top:12px"'+tipRows("Próxima categoria — como foi inferido",[
          ["Condição","pedidos após "+pc.de],
          ["Transições observadas",NUM(pc.k)+" de "+NUM(pc.n)],
          ["Taxa condicional",PCT0(pc.p)],
          ["Intervalo 95%",PCT0(pc.lo)+"–"+PCT0(pc.hi),"hl"],
          [null],
          ["Linha de base da loja",PCT0(pc.p0)],
          ["Ganho sobre a base",(pc.lift>=0?"+":"")+Math.round(pc.lift*100)+"%",vale?"good":"bad"],
          [null],
          ["Critério","limite inferior > linha de base"],
          ["Veredito",vale?"sinal de sequência":"não distinguível",vale?"good":"bad"]
        ],vale
          ? "Depois de "+pc.de+", "+pc.cat+" aparece em "+PCT0(pc.p)+" dos casos, contra "+PCT0(pc.p0)+" do fluxo normal da loja. Como o intervalo inteiro fica acima da base, não é só popularidade de catálogo."
          : "A taxa condicional ("+PCT0(pc.p)+") não se separa da taxa normal da loja ("+PCT0(pc.p0)+"). Afirmar sequência aqui seria confundir produto popular com padrão de jornada.")
        +'><span class="cid-row-lbl">'+ic("target")+'Próxima provável</span>'
        +'<span class="cid-row-val'+(vale?" acc":"")+'">'+(vale?esc(pc.cat):"indefinida")
        +' <small>'+(vale?PCT0(pc.p)+" vs "+PCT0(pc.p0)+" base":"sem sinal")+'</small></span></div>';
    }
    if(M.catNaoExplorada)
      body+=row2("bulb","Categoria inexplorada",esc(M.catNaoExplorada.c),"warn",
        tipRows("Cross-sell",[["Categoria",M.catNaoExplorada.c],["Unidades vendidas na loja",NUM(M.catNaoExplorada.n)]],
          "Popular na loja e nunca comprada por este cliente."));
  }
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("box")+'Afinidade de produto</h2>'
    +'<span class="cid-tag">'+NUM(M.produtos.length)+' produtos · '+NUM(M.categorias.length)+' categorias</span></div>'
    +'<div class="cid-panel-body">'+body+'</div></div>';
}
function precoPanel(M){
  var body='';
  /* Classificar sensibilidade por faixa fixa (">=80% = muito alta") ignora que
     com 4 pedidos "80%" são 4 em 5. A leitura só sai quando o intervalo do
     cliente se separa da taxa da loja. */
  var baseDesc=(M.storeAvg&&M.storeAvg.pct_com_desconto);
  var kDesc=Math.round(M.pctComDesconto*M.n);
  var tDesc=(baseDesc!=null&&M.n)?vsBase(kDesc,M.n,baseDesc):null;
  var sens;
  if(!M.n) sens={lbl:"sem pedidos",cls:""};
  else if(!tDesc) sens={lbl:PCT0(M.pctComDesconto)+" dos pedidos",cls:""};
  else if(tDesc.acima) sens={lbl:"Acima da base",cls:"warn"};
  else if(tDesc.abaixo) sens={lbl:"Abaixo da base",cls:"good"};
  else sens={lbl:"Como a base",cls:""};
  body+=row2("tag","Sensibilidade a desconto",sens.lbl,sens.cls,
    tipRows("Dependência de incentivo",[
      ["Pedidos com desconto",NUM(kDesc)+" de "+NUM(M.n)+" ("+PCT0(M.pctComDesconto)+")"],
      tDesc?["Intervalo 95%",ciTxt(tDesc.w),"hl"]:null,
      baseDesc!=null?["Taxa da loja",PCT0(baseDesc)]:null,
      [null],
      ["Critério","intervalo inteiro de um lado da base"],
      tDesc?["Veredito",tDesc.signif?(tDesc.acima?"mais sensível que a base":"menos sensível que a base"):"não distinguível",tDesc.signif?(tDesc.acima?"bad":"good"):""]:null,
      [null],
      ["Receita em promoção",PCT0(M.pctReceitaPromo)],
      ["Desconto médio/pedido",BRL(M.descontoMedio)],
      ["Maior desconto",BRL(M.maiorDesconto)]
    ],tDesc&&!tDesc.signif
      ? "Com "+M.n+" pedidos o intervalo ("+ciTxt(tDesc.w)+") cruza a taxa da loja ("+PCT0(baseDesc)+"). Chamar de 'sensível a desconto' aqui seria ler ruído como perfil."
      : (tDesc&&tDesc.acima
        ? PCT0(M.pctComDesconto)+" dos pedidos com desconto [IC95 "+ciTxt(tDesc.w)+"], contra "+PCT0(baseDesc)+" da base — o intervalo inteiro fica acima."
        : "")));
  body+=row2("money","Pedidos com desconto",PCT0(M.pctComDesconto)+' <small>· '+NUM(Math.round(M.pctComDesconto*M.n))+' de '+NUM(M.n)+'</small>',
    M.pctComDesconto>0.6?"warn":"");
  body+=row2("chart","Receita a preço cheio",BRL(M.receitaPrecoCheio)+' <small>· '+PCT0(1-M.pctReceitaPromo)+'</small>',"good");
  body+=row2("bolt","Desconto total concedido",BRL(M.desconto),M.desconto>0?"bad":"");
  body+=row2("list","Preço médio por item",BRL(M.precoMedioItem),"",
    tipRows("Preço por item",[
      ["Pago em média",BRL(M.precoMedioItem)],
      ["Preço cheio de catálogo",BRL(M.precoCheioMedio)],
      ["Desconto implícito",PCT(M.descontoImplicito),M.descontoImplicito>0.15?"bad":"good"],
      [null],
      ["Faixa favorita",M.faixaPreco,"hl"]
    ]));
  body+=row2("tag","Cupons distintos",NUM(M.cupons.length)+(M.cupomTop?' <small>· '+esc(M.cupomTop)+'</small>':""),
    M.cupons.length?"warn":"good");
  body+=row2("truck","Frete médio",BRL(M.freteMed)+' <small>· '+PCT(M.fretePctTicket)+' do ticket</small>',"",
    tipRows("Frete",[
      ["Cobrado do cliente",BRL(M.freteCob)],
      ["Custo real (Frenet)",BRL(M.freteReal),"bad"],
      ["Absorvido pela loja",BRL(M.fretePago),"bad"],
      [null],
      ["Pedidos com frete grátis",PCT0(M.pctFreteGratis)],
      ["Margem depois do frete",PCT(M.ltv?(M.lucro)/M.ltv:0)]
    ]));
  body+=row2("gauge","Frete grátis",PCT0(M.pctFreteGratis),M.pctFreteGratis>0.7?"warn":"");
  /* margem sacrificada */
  if(M.desconto>0)
    body+=row2("shield","Margem sacrificada",BRL(M.desconto+M.fretePago)+' <small>· '+PCT(M.ltv?(M.desconto+M.fretePago)/M.ltv:0)+'</small>',"bad",
      tipRows("Quanto custou manter este cliente",[
        ["Descontos",BRL(M.desconto),"bad"],
        ["Frete absorvido",BRL(M.fretePago),"bad"],
        [null],
        ["Total",BRL(M.desconto+M.fretePago),"bad"],
        ["Sobre a receita",PCT(M.ltv?(M.desconto+M.fretePago)/M.ltv:0)],
        ["Lucro mesmo assim",BRL(M.lucro),M.lucro>=0?"good":"bad"]
      ]));
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("tag")+'Preço, desconto e frete</h2>'
    +'<span class="cid-tag '+sens.cls+'">'+sens.lbl+'</span></div>'
    +'<div class="cid-panel-body"><div class="cid-grid2">'+body+'</div></div></div>';
}

/* ---------------------------- 2col: canal | tempo ---------------------------- */
function duoCanalTempo(M){
  return '<div class="cid-2col">'+canalPanel(M)+tempoPanel(M)+'</div>';
}
function canalPanel(M){
  var body='';
  if(M.jornada.length){
    body+='<div class="cid-journey">'+M.jornada.map(function(k,i){
      var cls=i===0?"is-first":(i===M.jornada.length-1?"is-last":"");
      return (i?'<span class="cid-jn-arrow">'+ic("arrow")+'</span>':'')
        +'<span class="cid-jn '+cls+'"><span class="cid-src-dot" style="background:'+canalCor(k)+'"></span>'+esc(k)+'</span>';
    }).join("")+'</div>';
  }
  var max=M.canais[0]?M.canais[0].pedidos:1;
  body+='<div class="cid-src-grid" style="margin-top:10px">'+M.canais.slice(0,6).map(function(x){
    var col=canalCor(x.canal);
    return '<div class="cid-src"'+tipRows("Canal "+x.canal,[
        ["Pedidos",NUM(x.pedidos)],
        ["Receita",BRL(x.receita)],
        ["Ticket no canal",BRL(x.pedidos?x.receita/x.pedidos:0)],
        [null],
        ["Participação",PCT0(x.pct),"hl"]
      ])+'>'
      +'<div class="cid-src-top"><span class="cid-src-name"><span class="cid-src-dot" style="background:'+col+'"></span>'+esc(x.canal)+'</span>'
      +'<span class="cid-src-pct" data-to="'+x.pct+'" data-fmt="pct">0%</span></div>'
      +'<div class="cid-src-bar"><div class="cid-src-fill" style="background:'+col+'" data-w="'+((x.pedidos/max)*100).toFixed(0)+'"></div></div>'
      +'<span class="cid-src-sub">'+NUM(x.pedidos)+' pedido'+(x.pedidos==1?"":"s")+' · '+kBRL(x.receita)+'</span></div>';
  }).join("")+'</div>';
  body+='<div style="margin-top:12px">';
  body+=row2("route","Primeiro toque",esc(M.canalPrimeiro||"—"));
  body+=row2("target","Último toque",esc(M.canalUltimo||"—"),M.canalUltimo==="Direto"?"good":"");
  if(M.campanhaPrimeira) body+=row2("bolt","Campanha de aquisição",esc(M.campanhaPrimeira));
  if(M.n>=2) body+=row2("shield","Compras diretas (2ª metade)",PCT0(M.diretoAgora),M.diretoAgora>=0.5?"good":"",
    tipRows("Dependência de tráfego pago",[
      ["Canal de aquisição",M.canalPrimeiro],
      ["Pedidos diretos na 2ª metade",PCT0(M.diretoAgora)],
      [null],
      ["Leitura",M.diretoAgora>=0.5?"já compra sozinho":"ainda depende de mídia","hl"]
    ]));
  body+='</div>';
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("route")+'Aquisição e jornada de canal</h2>'
    +'<span class="cid-tag">'+NUM(M.canais.length)+' canais</span></div>'
    +'<div class="cid-panel-body">'+body+'</div></div>';
}
function tempoPanel(M){
  var maxWd=Math.max.apply(null,M.wd)||1;
  var top=M.wd.indexOf(maxWd);
  var wdBars=WD.map(function(d,i){
    return '<div class="cid-bar-row'+(i===top&&M.wd[i]>0?" is-top":"")+'"'+tipRows(WD_LONGO[i],[
        ["Pedidos",NUM(M.wd[i])],
        ["Receita",BRL(M.wdRec[i])],
        ["Participação",PCT0(M.n?M.wd[i]/M.n:0),"hl"]
      ])+'>'
      +'<span class="cid-bar-lbl">'+d+'</span>'
      +'<div class="cid-bar-track"><div class="cid-bar-fill" data-w="'+((M.wd[i]/maxWd)*100).toFixed(0)+'"></div></div>'
      +'<span class="cid-bar-val" data-to="'+M.wd[i]+'" data-fmt="num">0</span></div>';
  }).join("");
  var faixas=[["Madrugada",0,5],["Manhã",6,11],["Tarde",12,17],["Noite",18,23]];
  var fData=faixas.map(function(f){ var s=0; for(var h=f[1];h<=f[2];h++) s+=M.hr[h]; return {k:f[0],n:s}; });
  var maxF=Math.max.apply(null,fData.map(function(x){return x.n;}))||1;
  var fBars=fData.map(function(x){
    return '<div class="cid-bar-row'+(x.n===maxF&&x.n>0?" is-top":"")+'"'+tipRows(x.k,[
        ["Pedidos",NUM(x.n)],["Participação",PCT0(M.n?x.n/M.n:0),"hl"]
      ])+'>'
      +'<span class="cid-bar-lbl">'+x.k+'</span>'
      +'<div class="cid-bar-track"><div class="cid-bar-fill" data-w="'+((x.n/maxF)*100).toFixed(0)+'"></div></div>'
      +'<span class="cid-bar-val" data-to="'+x.n+'" data-fmt="num">0</span></div>';
  }).join("");
  var body='<div style="font-size:9px;text-transform:uppercase;letter-spacing:.08em;color:var(--mut);margin-bottom:6px">Dia da semana</div>'+wdBars
    +'<div style="font-size:9px;text-transform:uppercase;letter-spacing:.08em;color:var(--mut);margin:14px 0 6px">Faixa horária</div>'+fBars
    +'<div style="margin-top:12px">'
    +row2("clock","Horário de pico",(M.n?M.bestHr+"h":"—"),"acc")
    +row2("calendar","Perfil semanal",M.fimDeSemana>M.diasUteis?"Fim de semana":"Dias úteis","")
    +'</div>';
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("clock")+'Comportamento temporal</h2>'
    +'<span class="cid-tag">'+esc(M.faixaHoraria.lbl)+' · '+PCT0(M.pctFaixa)+'</span></div>'
    +'<div class="cid-panel-body">'+body+'</div></div>';
}

/* ---------------------------- comparação com a base ---------------------------- */
function comparaBase(M){
  if(!M.hasBase){
    return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("compare")+'Comparação com a base</h2>'
      +'<span class="cid-tag">sem dados</span></div>'
      +'<div class="cid-panel-body"><p class="cid-note">Os agregados da base ainda estão carregando. A comparação aparece assim que o recurso <b>customer_base</b> responder.</p></div></div>';
  }
  var sa=M.storeAvg||{};
  function cx(key,lbl,icon,val,avg,fmt,maiorMelhor,extra){
    var f = fmt==="brl"?BRL:fmt==="pct"?PCT:fmt==="kbrl"?kBRL:fmt==="dias"?DIAS:NUM;
    var v=Number(val)||0;
    var tem = avg!=null && isFinite(avg);
    var delta = tem ? (avg!==0 ? (v-avg)/Math.abs(avg) : (v>0?1:0)) : null;
    var bom = delta==null?null:(maiorMelhor?delta>=0:delta<=0);
    var dTxt = delta==null?"—":((delta>=0?"+":"")+Math.round(delta*100)+"% vs média");
    var r = key&&M.faixa[key]&&isFinite(M.faixa[key].min)&&M.faixa[key].max>M.faixa[key].min ? M.faixa[key] : null;
    var pos;
    if(r&&tem){ var half=Math.max(Math.abs(r.max-avg),Math.abs(avg-r.min))||1; pos=clamp(50+(v-avg)/half*48,2,98); }
    else pos=delta==null?50:clamp(50+delta*48,2,98);
    var lo=Math.min(pos,50), wd=Math.abs(pos-50);
    var tone=bom===null?"":(bom?"pos":"neg");
    var rows=[["Este cliente",f(v),"hl"],["Média da base",tem?f(avg):"—"]];
    if(r) rows.push(["Faixa da base",f(r.min)+" – "+f(r.max)]);
    rows.push([null]);
    rows.push(["Diferença",dTxt,bom?"good":"bad"]);
    if(extra) extra.forEach(function(e){ rows.push(e); });
    return '<div class="cid-cx2"'+tipRows(lbl,rows)+'>'
      +'<div class="cid-cx2-head"><span class="cid-cx2-ic '+tone+'">'+ic(icon)+'</span><span class="cid-cx2-lbl">'+lbl+'</span>'
      +'<span class="cid-cx2-chip '+(bom===null?"":(bom?"up":"down"))+'">'+dTxt+'</span></div>'
      +'<div class="cid-cx2-val" data-to="'+v+'" data-fmt="'+fmt+'">'+f(0)+'</div>'
      +'<div class="cid-cx2-gauge"><span class="cx2-fill '+tone+'" data-left="'+lo.toFixed(1)+'" data-w="'+wd.toFixed(1)+'" style="left:50%"></span>'
      +'<span class="cx2-avgtick"></span></div>'
      +'<div class="cid-cx2-foot"><span class="cx2-mid">'+(tem?"méd "+f(avg):"sem média")+'</span></div></div>';
  }
  var grid='<div class="cid-cx2-grid">'
    +cx("ltv","LTV","money",M.ltv,M.avg.ltv,"kbrl",true,
        [["Posição","#"+NUM(M.rank.receita)+" de "+NUM(M.total)],["Percentil",Math.round(M.pctl.receita*100)+"º"],
         ["Share do faturamento",PCT(M.shareReceita)]])
    +cx("lucro","Lucro","chart",M.lucro,M.avg.lucro,"kbrl",true,
        [["Posição","#"+NUM(M.rank.lucro)+" de "+NUM(M.total)],["Share do lucro",PCT(M.shareLucro)]])
    +cx("ticket","Ticket médio","compare",M.ticket,M.avg.ticket,"brl",true,
        [["Posição","#"+NUM(M.rank.ticket)+" de "+NUM(M.total)],
         M.regiaoStats&&M.regiaoStats.n?["Média da região",BRL(M.regiaoStats.ticket)]:null])
    +cx("pedidos","Pedidos","cart",M.n,M.avg.pedidos,"num",true,
        [["Posição","#"+NUM(M.rank.pedidos)+" de "+NUM(M.total)]])
    +cx("margem","Margem","gauge",M.margem,M.avg.margem,"pct",true)
    +cx(null,"Ciclo de recompra","repeat",M.ciclo,M.intervals&&M.intervals.p50,"dias",false,
        M.intervals?[["Mediana da base",DIAS(M.intervals.p50||0)],["25% mais rápidos",DIAS(M.intervals.p25||0)]]:null)
    +cx(null,"Pedidos com desconto","tag",M.pctComDesconto,sa.pct_com_desconto,"pct",false,
        [["Receita em promoção",PCT0(M.pctReceitaPromo)]])
    +cx(null,"Itens por pedido","box",M.itensPed,sa.itens_pedido,"num",true)
    +'</div>';
  /* faixa de rankings, em destaque */
  var ranks='<div class="cid-rank-grid">'
    +rank("Receita",M.rank.receita,M.total,M.pctl.receita)
    +rank("Lucro",M.rank.lucro,M.total,M.pctl.lucro)
    +rank("Pedidos",M.rank.pedidos,M.total,M.pctl.pedidos)
    +rank("Ticket",M.rank.ticket,M.total,M.pctl.ticket)
    +'</div>';
  var topPct=Math.max(1,Math.round((1-M.pctl.receita)*100));
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("compare")+'Comparação com a base</h2>'
    +'<span class="cid-cx-leg"><span class="cx-leg-tipo">'+NUM(M.total)+' clientes</span>'
    +'<i class="lg up"></i>acima<i class="lg down"></i>abaixo</span></div>'
    +'<div class="cid-panel-body" style="padding:0">'+ranks+grid+'</div>'
    +'<div class="cid-panel-body" style="border-top:1px solid var(--line)"><p class="cid-note" style="font-style:normal">'
    +ic("trophy")+' Está entre os <b style="color:var(--acc)">'+topPct+'%</b> de maior valor da base e representa '
    +'<b style="color:var(--acc)">'+PCT(M.shareReceita)+'</b> do faturamento total.</p></div></div>';
}
function rank(lbl,pos,total,pctl){
  var top=Math.max(1,Math.round((1-pctl)*100));
  return '<div class="cid-rank"'+tipRows("Ranking por "+lbl.toLowerCase(),[
      ["Posição","#"+NUM(pos)],["Total de clientes",NUM(total)],
      [null],["Percentil",Math.round(pctl*100)+"º","hl"],["Faixa","top "+top+"%"]
    ])+'>'
    +'<div class="cid-rank-val acc">#<span data-to="'+pos+'" data-fmt="num">0</span></div>'
    +'<div class="cid-rank-lbl">'+lbl+'</div>'
    +'<div class="cid-rank-sub">top '+top+'% de '+NUM(total)+'</div></div>';
}

/* ---------------------------- devoluções ---------------------------- */
function painelDevolucoes(M){
  if(!M.devTotal) return "";
  var rows='';
  rows+=row2("swap","Devoluções / trocas",NUM(M.nDev)+" dev · "+NUM(M.nTroca)+" trocas","bad");
  rows+=row2("gauge","Taxa sobre pedidos",PCT(M.taxaDev),M.taxaDev>0.2?"bad":"warn");
  rows+=row2("money","Valor devolvido",BRL(M.valorDevolvido),"bad");
  rows+=row2("truck","Custo logístico",BRL(M.custoDevLog),"bad");
  rows+=row2("chart","Lucro líquido real",BRL(M.lucroLiquido),M.lucroLiquido>=0?"good":"bad",
    tipRows("Lucro depois das devoluções",[
      ["Lucro bruto",BRL(M.lucro)],
      ["Custo logístico de devolução",BRL(M.custoDevLog),"bad"],
      [null],
      ["Lucro líquido",BRL(M.lucroLiquido),M.lucroLiquido>=0?"good":"bad"],
      ["Margem líquida",PCT(M.ltv?M.lucroLiquido/M.ltv:0)]
    ]));
  if(M.motivoTop) rows+=row2("alert","Motivo predominante",esc(M.motivoTop)+' <small>· '+M.motivoTopN+'×</small>',"warn");
  if(M.tamDevTop) rows+=row2("ruler","Tamanho mais devolvido",esc(M.tamDevTop)+' <small>· '+M.tamDevTopN+'×</small>',"bad");
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("swap")+'Devoluções e trocas</h2>'
    +'<span class="cid-tag bad">'+NUM(M.devTotal)+' registros</span></div>'
    +'<div class="cid-panel-body">'+rows+'</div></div>';
}

/* ---------------------------- histórico de pedidos ---------------------------- */
function historico(M){
  if(!M.allOrders.length) return "";
  var lista=M.allOrders.slice(0,30);
  var linhas=lista.map(function(o,i){
    var st="mc-pill s-"+String(o.status||"").replace(/[^a-zà-ú]/gi,"").toLowerCase();
    var its=M.items.filter(function(it){ return String(it.order_id)===String(o.id); });
    var qtd=nz(o.itens_qtd)||its.reduce(function(s,it){ return s+(nz(it.quantity)||1); },0);
    var lucro=nz(o.lucro), desc=nz(o.desconto), frete=nz(o.frete_cobrado);
    var gap=null;
    var pos=M.asc.map(function(x){return String(x.id);}).indexOf(String(o.id));
    if(pos>0) gap=Math.round((new Date(o.created_at)-new Date(M.asc[pos-1].created_at))/86400000);
    var tipPedido=tipRows("Pedido #"+String(o.order_number||o.id),[
      ["Data",DATE(o.created_at)],
      ["Status",String(o.status||"—")],
      [null],
      ["Subtotal",BRL(nz(o.subtotal)||nz(o.receita_produtos))],
      ["Desconto",desc?"− "+BRL(desc):"nenhum",desc?"bad":"good"],
      o.cupom?["Cupom",String(o.cupom)]:null,
      ["Frete cobrado",BRL(frete)],
      ["Frete real",BRL(nz(o.frete_real)),"bad"],
      ["Faturamento",BRL(nz(o.faturamento)),"hl"],
      [null],
      ["CMV",BRL(nz(o.cogs)),"bad"],
      ["Embalagem",BRL(nz(o.embalagem)),"bad"],
      ["Taxa de gateway",BRL(nz(o.taxa_gateway)),"bad"],
      ["Lucro",BRL(lucro),lucro>=0?"good":"bad"],
      ["Margem",PCT(nz(o.margem))],
      [null],
      ["Canal",String(o.origem||"—")],
      ["Pagamento",String(o.metodo_pagamento||"—")],
      gap!=null?["Desde o pedido anterior",DIAS(gap)]:null
    ]);
    var tipItens = its.length
      ? ' data-tip="itens" data-oid-items="'+esc(String(o.id))+'"'
      : tipRows("Itens",[["Quantidade",NUM(qtd)]],"O detalhamento por item aparece após a sincronização.");
    return '<tr data-oid="'+esc(String(o.id))+'"'+tipPedido+'>'
      +'<td>'+DATE(o.created_at)+'</td>'
      +'<td>#'+esc(String(o.order_number||o.id))+'</td>'
      +'<td class="c hasTip"'+tipItens+'><span class="cid-qtd">'+ic("box")+NUM(qtd)+'</span></td>'
      +'<td class="r">'+BRL(nz(o.faturamento))+'</td>'
      +'<td class="r'+(desc>0?" bad":"")+'">'+(desc>0?"−"+BRL(desc):"—")+'</td>'
      +'<td class="r">'+(frete>0?BRL(frete):'<span style="color:var(--good)">grátis</span>')+'</td>'
      +'<td class="r" style="color:'+(lucro>=0?"var(--good)":"var(--bad)")+'">'+BRL(lucro)+'</td>'
      +'<td class="r">'+PCT(nz(o.margem))+'</td>'
      +'<td>'+esc(String(o.origem||"—"))+'</td>'
      +'<td><span class="'+st+'">'+esc(String(o.status||"—"))+'</span></td></tr>';
  }).join("");
  /* mapa de itens por pedido, consultado pelo tooltip */
  var mapa={};
  M.items.forEach(function(it){ (mapa[String(it.order_id)]=mapa[String(it.order_id)]||[]).push(it); });
  window._cidItems=mapa;
  return '<div class="cid-panel"><div class="cid-panel-head"><h2>'+ic("list")+'Histórico de pedidos</h2>'
    +'<span class="cid-tag">'+NUM(M.allOrders.length)+' pedidos · '+BRL(M.ltv)+'</span></div>'
    +'<div class="cid-panel-body" style="padding:0;overflow-x:auto"><table class="cid-tbl">'
    +'<thead><tr><th>Data</th><th>Pedido</th><th class="c">Itens</th><th class="r">Valor</th><th class="r">Desconto</th>'
    +'<th class="r">Frete</th><th class="r">Lucro</th><th class="r">Margem</th><th>Canal</th><th>Status</th></tr></thead>'
    +'<tbody>'+linhas+'</tbody></table>'
    +(M.allOrders.length>30?'<div style="color:var(--mut);font-size:10px;padding:9px 12px;border-top:1px solid var(--line)">... mais '+(M.allOrders.length-30)+' pedidos</div>':'')
    +'</div></div>';
}

/* ==========================================================================
   TOOLTIPS — um só elemento, delegação no root (motor da página de pedidos)
   ========================================================================== */
function wireTips(){
  var root=document.getElementById("mc-root");
  if(!root||root._tipBound) return;
  root._tipBound=true;
  var tip=document.createElement("div"); tip.className="cid-tip"; root.appendChild(tip);
  var _el=null,_mx=0,_my=0,_hideT=null,_inter=false;

  function linha(l,v,cls){
    if(l===null||l===undefined) return '<div class="pt-sep"></div>';
    var c=cls==="hl"?" pt-hl":cls==="good"?" pt-good":cls==="bad"?" pt-bad":"";
    return '<div class="pt-row'+c+'"><span>'+l+'</span><b>'+v+'</b></div>';
  }
  function corpo(el){
    var t=el.getAttribute("data-tip");
    if(t==="rows"){
      var raw=el.getAttribute("data-rows"); if(!raw) return "";
      var d; try{ d=JSON.parse(raw); }catch(e){ return ""; }
      var h=d.h?'<div class="pt-hd">'+esc(d.h)+'</div>':'';
      (d.r||[]).forEach(function(r){
        if(!r) return;                       // entradas condicionais viram null
        if(r[0]===null||r.length===0){ h+=linha(null); return; }
        h+=linha(esc(String(r[0])),esc(String(r[1]==null?"—":r[1])),r[2]);
      });
      if(d.n) h+='<div class="pt-note">'+esc(d.n)+'</div>';
      return h;
    }
    if(t==="itens"){
      var oid=el.getAttribute("data-oid-items");
      var its=(window._cidItems||{})[oid]||[];
      if(!its.length) return '<div class="pt-hd">Itens</div><div class="pt-note">Sem detalhamento.</div>';
      var h2='<div class="pt-hd">Itens do pedido</div>';
      h2+=its.map(function(it){
        var det=[];
        if(it.tamanho) det.push(esc(it.tamanho));
        if(it.cor) det.push(esc(it.cor));
        if(it.is_kit&&it.title) det.push("via "+esc(it.title));
        var nome=esc(it.nome_exibicao||it.title||it.sku||"—");
        var lbl=nome+(det.length?' <span class="pt-sub">'+det.join(" · ")+'</span>':'');
        var lid=it.link_id||"";
        return linha(lid?('<a class="pt-link" href="'+PAGE_PRODUTO+'?id='+encodeURIComponent(lid)+'">'+lbl+'</a>'):lbl,
          (nz(it.quantity)||1)+" × "+BRL(it.price));
      }).join("");
      var tot=its.reduce(function(s,it){ return s+nz(it.line_revenue); },0);
      var un =its.reduce(function(s,it){ return s+(nz(it.quantity)||1); },0);
      h2+=linha(null)+linha(NUM(un)+" itens",BRL(tot),"hl");
      return h2;
    }
    return "";
  }
  function show(el,mx,my){
    _el=el;_mx=mx;_my=my;
    var h=corpo(el); if(!h) return;
    tip.innerHTML=h;
    var interativo=(el.getAttribute("data-tip")==="itens");
    tip.classList.toggle("is-interactive",interativo);
    var jaAberto=(_inter&&interativo&&tip.style.display==="block");
    _inter=interativo;
    tip.style.display="block";
    if(jaAberto) return;   // trava a posição enquanto dá pra clicar nos links
    var x=mx+15,y=my-tip.offsetHeight/2;
    if(x+tip.offsetWidth>window.innerWidth) x=mx-tip.offsetWidth-12;
    if(x<4) x=4;
    if(y<4) y=4;
    if(y+tip.offsetHeight>window.innerHeight) y=window.innerHeight-tip.offsetHeight-4;
    tip.style.left=x+"px"; tip.style.top=y+"px";
  }
  function hide(){ clearTimeout(_hideT); tip.style.display="none"; tip.classList.remove("is-interactive"); _el=null; _inter=false; }
  /* carência para o mouse atravessar o vão até o tooltip clicável */
  function hideSoon(){ clearTimeout(_hideT); _hideT=setTimeout(hide,_inter?220:0); }
  tip.addEventListener("mouseenter",function(){ clearTimeout(_hideT); });
  tip.addEventListener("mouseleave",hide);
  root.addEventListener("mouseover",function(ev){
    var el=ev.target.closest("[data-tip]");
    if(el){ clearTimeout(_hideT); show(el,ev.clientX,ev.clientY); }
  });
  root.addEventListener("mousemove",function(ev){
    if(tip.style.display==="none") return;
    var el=ev.target.closest("[data-tip]");
    if(el){ clearTimeout(_hideT); show(el,ev.clientX,ev.clientY); }
    else if(!tip.contains(ev.target)) hideSoon();
  });
  root.addEventListener("mouseout",function(ev){ if(!ev.target.closest("[data-tip]")) hideSoon(); });
  window.addEventListener("scroll",function(){ if(tip.style.display==="block"&&!_inter) hide(); },true);
}

/* ==========================================================================
   INSIGHTS — botão flutuante + drawer seccionado
   Mesmo motor pontuado da página de produto; aqui o corpo é dividido em
   famílias porque o volume de cruzamento é muito maior.
   Cada item = negrito (o achado, com número) + regular (a leitura).
   ========================================================================== */
var FAMILIAS=[
  {k:"valor",     lbl:"Valor e importância",     ico:"trophy"},
  {k:"rfm",       lbl:"Segmentação RFM",         ico:"crown"},
  {k:"recorr",    lbl:"Recorrência e ciclo",     ico:"repeat"},
  {k:"risco",     lbl:"Propensão e risco",       ico:"gauge"},
  {k:"gasto",     lbl:"Evolução do gasto",       ico:"chart"},
  {k:"margem",    lbl:"Margem e rentabilidade",  ico:"money"},
  {k:"preco",     lbl:"Preço e desconto",        ico:"tag"},
  {k:"frete",     lbl:"Frete",                   ico:"truck"},
  {k:"produto",   lbl:"Produto e afinidade",     ico:"box"},
  {k:"tamanho",   lbl:"Tamanho e caimento",      ico:"ruler"},
  {k:"seq",       lbl:"Sequência de compra",     ico:"arrow"},
  {k:"entrada",   lbl:"Primeiro produto",        ico:"star"},
  {k:"carrinho",  lbl:"Carrinho e composição",   ico:"cart"},
  {k:"canal",     lbl:"Aquisição e canal",       ico:"route"},
  {k:"drop",      lbl:"Drops e lançamentos",     ico:"layers"},
  {k:"tempo",     lbl:"Horário e sazonalidade",  ico:"clock"},
  {k:"geo",       lbl:"Geografia",               ico:"pin"},
  {k:"devol",     lbl:"Devoluções e trocas",     ico:"swap"},
  {k:"coorte",    lbl:"Coorte de aquisição",     ico:"compare"},
  {k:"anomalia",  lbl:"Anomalias",               ico:"alert"},
  {k:"potencial", lbl:"Potencial não capturado", ico:"target"}
];

function construirInsights(M){
  var C=[];
  function add(cat,score,tone,ico,lead,rest){ if(score>0) C.push({cat:cat,score:score,tone:tone,ico:ico,lead:lead,rest:rest}); }
  var sa=M.storeAvg||{}, iv=M.intervals||{};
  var temBase=M.hasBase;
  var topPct = temBase ? Math.max(1,Math.round((1-M.pctl.receita)*100)) : 0;

  /* ── 1. VALOR E IMPORTÂNCIA ── */
  if(temBase){
    if(M.rank.receita<=10)
      add("valor",clamp(86+(10-M.rank.receita),0,96),"acc","trophy","#"+M.rank.receita+" em receita entre "+NUM(M.total)+" clientes",
        M.rank.receita===1?"é o cliente mais valioso da operação.":"está no topo absoluto da base.");
    else if(M.pctl.receita>=0.95)
      add("valor",78,"acc","trophy","Top "+topPct+"% da base por receita","cliente de altíssimo valor — trate como conta estratégica.");
    else if(M.pctl.receita>=0.9)
      add("valor",62,"acc","star","Top "+topPct+"% da base por receita","acima da imensa maioria dos clientes.");
    if(M.shareReceita>=0.01)
      add("valor",clamp(40+M.shareReceita*900,0,84),"acc","money",PCT(M.shareReceita)+" do faturamento da loja",
        "peso relevante do resultado concentrado numa pessoa só.");
    if(M.shareLucro>=0.012)
      add("valor",clamp(38+M.shareLucro*800,0,80),"acc","chart",PCT(M.shareLucro)+" do lucro total","contribuição desproporcional ao tamanho da base.");
    var rLtv=multi(M.ltv,M.avg.ltv);
    if(rLtv>=1.8) add("valor",clamp(34+rLtv*10,0,76),"pos","money","LTV "+rLtv.toFixed(1)+"× a média da base",
      "gasta "+BRL(M.ltv)+" contra "+BRL(M.avg.ltv)+" do cliente médio.");
    else if(rLtv>0 && rLtv<=0.45 && M.n>=2) add("valor",34,"warn","money","LTV "+PCT0(rLtv)+" da média",
      "abaixo do cliente médio mesmo com "+NUM(M.n)+" pedidos.");
    var rTk=multi(M.ticket,M.avg.ticket);
    if(rTk>=1.35) add("valor",clamp(30+rTk*14,0,70),"pos","compare","Ticket "+rTk.toFixed(1)+"× a média","perfil premium: "+BRL(M.ticket)+" por pedido.");
    else if(rTk>0&&rTk<=0.7) add("valor",32,"warn","compare","Ticket "+PCT0(rTk)+" da média","compra tíquetes pequenos — espaço para upsell.");
    if(M.rank.lucro<=15 && M.rank.receita>M.rank.lucro)
      add("valor",58,"pos","chart","#"+M.rank.lucro+" em lucro (melhor que a posição em receita)","vende menos que outros, mas dá mais retorno.");
    if(M.pctl.receita>=0.85 && M.margem<M.avg.margem*0.8 && M.avg.margem>0)
      add("valor",76,"warn","alert","Alto faturamento, margem baixa",
        "está no top "+topPct+"% em receita, mas com margem de "+PCT(M.margem)+" contra "+PCT(M.avg.margem)+" da base.");
    if(M.pctl.receita>=0.85 && M.pctReceitaPromo>=0.7)
      add("valor",80,"warn","tag","Valor sustentado por desconto",
        PCT0(M.pctReceitaPromo)+" da receita deste cliente veio de pedidos promocionais.");
    if(M.pctl.receita>=0.8 && M.n>=4 && M.margem>=M.avg.margem)
      add("valor",84,"pos","crown","Perfil VIP completo","valor alto, recorrência consistente e margem acima da média — os três ao mesmo tempo.");
  }

  /* ── 2. RFM ── */
  if(M.rfm){
    var s=M.rfm.seg;
    var det=[];
    if(temBase) det.push("está entre os "+topPct+"% de maior valor e os "+Math.max(1,Math.round((1-M.pctl.pedidos)*100))+"% de maior frequência");
    if(M.ciclo>0&&M.cicloRatio>1.2) det.push("mas já está "+M.cicloRatio.toFixed(1)+"× acima do intervalo normal entre compras");
    else if(M.ciclo>0) det.push("e está dentro do ciclo normal de "+DIAS(M.ciclo));
    add("rfm", s.k==="Champions"?90:s.k==="HVAR"?92:s.k==="AtRisk"?84:s.k==="Lost"?70:s.k==="Loyal"?72:52,
      s.tone,s.ico,"Segmento "+s.lbl+" (RFM "+M.rfm.codigo+")",
      det.length?det.join(", ")+".":"classificação a partir de recência, frequência e valor.");
  }

  /* ── 3. RECORRÊNCIA E CICLO ── */
  if(M.n===1){
    add("recorr",66,"warn","user","Cliente de compra única",
      "há "+DIAS(M.diasUltima||0)+" desde a primeira e única compra — a segunda compra é o maior salto de LTV disponível.");
  } else {
    if(M.ciclo>0)
      add("recorr",44,"acc","repeat","Recompra a cada "+DIAS(M.ciclo)+" (mediana)",
        "menor intervalo "+M.gapMin+"d, maior "+M.gapMax+"d — janela provável entre "+M.janelaIni+" e "+M.janelaFim+" dias.");
    if(M.ciclo>0 && M.cicloRatio>=1.35)
      add("recorr",clamp(58+M.cicloRatio*12,0,92),"neg","alert","Está "+Math.round((M.cicloRatio-1)*100)+"% além do ciclo normal",
        "há "+DIAS(M.diasUltima)+" sem comprar, contra "+DIAS(M.ciclo)+" de intervalo habitual.");
    else if(M.ciclo>0 && M.diasUltima<=M.janelaFim && M.diasUltima>=M.janelaIni)
      add("recorr",74,"pos","target","Dentro da janela de recompra",
        "costuma voltar entre "+M.janelaIni+" e "+M.janelaFim+" dias e está no dia "+M.diasUltima+" — momento ideal de acionar.");
    else if(M.ciclo>0 && M.cicloRatio<0.6)
      add("recorr",56,"pos","flame","Comprando acima do ritmo normal",
        "última compra há apenas "+DIAS(M.diasUltima)+", contra um ciclo de "+DIAS(M.ciclo)+" — fase ativa.");
    if(M.tendCiclo<=-0.25)
      add("recorr",62,"pos","bolt","Frequência acelerando "+Math.abs(Math.round(M.tendCiclo*100))+"%",
        "os últimos intervalos estão bem mais curtos que os primeiros — cliente engajando.");
    else if(M.tendCiclo>=0.35)
      add("recorr",64,"warn","clock","Frequência desacelerando "+Math.round(M.tendCiclo*100)+"%",
        "os intervalos entre compras vêm se alongando — sinal precoce de desengajamento.");
    if(M.reativacoes>=1)
      add("recorr",48,"acc","swap",NUM(M.reativacoes)+" reativação"+(M.reativacoes>1?"ões":"")+" no histórico",
        "já voltou depois de longos períodos parado — responde a estímulo.");
    if(M.gap1a2 && M.ciclo && M.gap1a2<M.ciclo*0.6)
      add("recorr",50,"pos","check","Segunda compra veio rápido ("+DIAS(M.gap1a2)+")","a conversão para recorrente foi mais rápida que o próprio ciclo.");
    if(iv.p50 && M.ciclo>0){
      if(M.ciclo<iv.p50*0.7) add("recorr",58,"pos","repeat","Recompra "+Math.round((1-M.ciclo/iv.p50)*100)+"% mais rápida que a base",
        "ciclo de "+DIAS(M.ciclo)+" contra "+DIAS(iv.p50)+" da mediana geral.");
      else if(M.ciclo>iv.p50*1.5) add("recorr",42,"warn","clock","Recompra mais lenta que a base",
        "ciclo de "+DIAS(M.ciclo)+" contra "+DIAS(iv.p50)+" da mediana geral.");
    }
    if(temBase && M.n>=Math.max(4,M.avg.pedidos*2))
      add("recorr",60,"pos","heart",NUM(M.n)+" pedidos ("+multi(M.n,M.avg.pedidos).toFixed(1)+"× a média)","cliente genuinamente leal.");
  }

  /* ── 4. PROPENSÃO E RISCO ── */
  if(M.pred.churn>=65)
    add("risco",clamp(70+M.pred.churn*0.25,0,94),"neg","alert","Risco de churn "+M.pred.churn+"%",
      "há "+DIAS(M.diasUltima||0)+" sem comprar"+(M.ciclo?", contra um intervalo histórico de "+DIAS(M.ciclo):"")+".");
  else if(M.pred.recompra>=70)
    add("risco",56,"pos","target","Propensão à recompra "+M.pred.recompra+"%","dentro do padrão de retorno — vale um empurrão leve, sem desconto.");
  if(M.pctComDesconto<0.25 && M.n>=3)
    add("risco",58,"pos","shield","Alta propensão a preço cheio",
      PCT0(1-M.pctReceitaPromo)+" da receita histórica veio sem cupom — não precisa de desconto para converter.");
  if(M.catTop && M.n>=3)
    add("risco",38,"acc","box","Maior propensão em "+M.catTop.k,
      PCT0(M.concentracaoCat)+" das unidades compradas são dessa categoria.");
  if(M.diasUltima!=null && M.diasUltima>120 && M.n>=2)
    add("risco",68,"neg","clock",DIAS(M.diasUltima)+" de inatividade","janela de reativação já bem aberta — cada semana reduz a chance de retorno.");

  /* ── 5. EVOLUÇÃO DO GASTO ── */
  if(M.n>=3){
    if(M.tendTicket>=0.3)
      add("gasto",clamp(48+M.tendTicket*40,0,82),"pos","chart","Ticket subiu "+Math.round(M.tendTicket*100)+"%",
        "média dos 3 últimos pedidos ("+BRL(M.media3Ultimos)+") contra os 3 primeiros ("+BRL(M.media3Primeiros)+").");
    else if(M.tendTicket<=-0.3)
      add("gasto",clamp(48+Math.abs(M.tendTicket)*40,0,82),"warn","chart","Ticket caiu "+Math.abs(Math.round(M.tendTicket*100))+"%",
        "de "+BRL(M.media3Primeiros)+" nos 3 primeiros para "+BRL(M.media3Ultimos)+" nos 3 últimos — deterioração de valor.");
    if(M.maiorPedido && nz(M.maiorPedido.faturamento)>M.ticket*2.2)
      add("gasto",44,"acc","bolt","Pedido excepcional de "+BRL(nz(M.maiorPedido.faturamento)),
        "mais que o dobro do próprio ticket médio, em "+DATE(M.maiorPedido.created_at)+".");
    if(M.itensPed>=2.5)
      add("gasto",40,"pos","cart",M.itensPed.toFixed(1)+" itens por pedido","carrinhos maiores que o pedido típico de um item só.");
  }
  if(M.ticketUltimo && M.ticketPrimeiro && M.n>=2){
    var r2=multi(M.ticketUltimo,M.ticketPrimeiro);
    if(r2>=1.8) add("gasto",46,"pos","arrow","Último pedido "+r2.toFixed(1)+"× o primeiro","upgrade claro de comportamento de compra.");
    else if(r2>0&&r2<=0.5) add("gasto",44,"warn","arrow","Último pedido "+PCT0(r2)+" do primeiro","migrando para compras menores.");
  }

  /* ── 6. MARGEM E RENTABILIDADE ── */
  if(temBase && M.avg.margem>0){
    var dM=M.margem-M.avg.margem;
    if(dM>=0.05) add("margem",clamp(44+dM*220,0,86),"pos","money","Margem "+Math.round(dM*100)+" p.p. acima da média",
      PCT(M.margem)+" contra "+PCT(M.avg.margem)+" do cliente médio — cliente barato de servir.");
    else if(dM<=-0.05) add("margem",clamp(44+Math.abs(dM)*220,0,86),"warn","money","Margem "+Math.abs(Math.round(dM*100))+" p.p. abaixo da média",
      PCT(M.margem)+" contra "+PCT(M.avg.margem)+" — revise desconto e frete concedidos.");
  }
  if(M.lucro>0) add("margem",34,"pos","chart","Lucro acumulado de "+BRL(M.lucro),
    BRL(M.lucroPed)+" por pedido em "+NUM(M.n)+" compras.");
  else if(M.n>=2 && M.lucro<=0) add("margem",82,"neg","alert","Cliente deficitário",
    "acumula "+BRL(M.lucro)+" de lucro em "+NUM(M.n)+" pedidos — custo de servir maior que a receita.");
  if(M.custoDevLog>0 && M.lucro>0 && M.custoDevLog/M.lucro>0.25)
    add("margem",72,"neg","swap","Devoluções consomem "+PCT0(M.custoDevLog/M.lucro)+" do lucro",
      BRL(M.custoDevLog)+" de custo logístico contra "+BRL(M.lucro)+" de lucro bruto.");
  if(M.desconto+M.fretePago>0 && M.ltv>0){
    var sac=(M.desconto+M.fretePago)/M.ltv;
    if(sac>=0.15) add("margem",clamp(40+sac*160,0,80),"warn","shield",PCT0(sac)+" da receita foi em incentivo",
      BRL(M.desconto)+" de desconto e "+BRL(M.fretePago)+" de frete absorvido para manter este cliente.");
  }

  /* ── 7. PREÇO E DESCONTO ── */
  if(M.n>=2){
    var baseD=sa.pct_com_desconto;
    if(M.pctComDesconto>=0.7)
      add("preco",clamp(52+M.pctComDesconto*30,0,88),"warn","tag",PCT0(M.pctComDesconto)+" dos pedidos com desconto",
        baseD!=null?("contra "+PCT0(baseD)+" da base — dependência clara de incentivo."):"dependência clara de incentivo.");
    else if(M.pctComDesconto<=0.2)
      add("preco",64,"pos","shield",PCT0(1-M.pctComDesconto)+" dos pedidos a preço cheio",
        baseD!=null?("contra "+PCT0(1-baseD)+" da base — margem preservada."):"não depende de promoção para comprar.");
    if(baseD!=null && M.pctComDesconto>baseD*1.6 && M.pctComDesconto>0.4)
      add("preco",76,"warn","alert","Sensibilidade a desconto acima da base",
        PCT0(M.pctComDesconto)+" dos pedidos ocorreram com desconto, contra "+PCT0(baseD)+" da base.");
    if(M.cupons.length>=3)
      add("preco",42,"warn","tag",NUM(M.cupons.length)+" cupons diferentes usados",
        M.cupomTop?("o mais recorrente é "+M.cupomTop+" ("+M.cupomTopN+"×) — testa toda promoção que recebe."):"testa toda promoção que recebe.");
    if(M.descontoImplicito>=0.2)
      add("preco",50,"warn","money","Paga "+PCT0(1-M.descontoImplicito)+" do preço de tabela",
        BRL(M.precoMedioItem)+" por item contra "+BRL(M.precoCheioMedio)+" de preço cheio.");
    if(M.maiorDesconto>0 && M.ticket>0 && M.maiorDesconto>M.ticket*0.4)
      add("preco",44,"warn","bolt","Maior desconto usado: "+BRL(M.maiorDesconto),
        "equivale a "+PCT0(M.maiorDesconto/M.ticket)+" de um ticket médio deste cliente.");
    if(M.faixaPreco&&M.faixaPreco!=="—")
      add("preco",30,"acc","list","Faixa de preço favorita: "+M.faixaPreco,"concentre ofertas nessa faixa para maximizar conversão.");
  }

  /* ── 8. FRETE ── */
  if(M.n>=2){
    if(M.pctFreteGratis>=0.8)
      add("frete",clamp(44+M.pctFreteGratis*30,0,78),"warn","truck",PCT0(M.pctFreteGratis)+" dos pedidos com frete grátis",
        (sa.pct_frete_gratis!=null?("contra "+PCT0(sa.pct_frete_gratis)+" da base — "):"")+"parece montar o carrinho para bater o threshold.");
    else if(M.pctFreteGratis<=0.15)
      add("frete",38,"pos","truck","Paga frete em "+PCT0(1-M.pctFreteGratis)+" dos pedidos","não é sensível ao custo logístico.");
    if(M.fretePago>0 && M.lucro>0 && M.fretePago/M.lucro>0.2)
      add("frete",60,"warn","truck","Frete absorvido come "+PCT0(M.fretePago/M.lucro)+" do lucro",
        BRL(M.fretePago)+" bancados pela loja"+(regiaoOf(M.c.estado)?" para entregar no "+regiaoOf(M.c.estado):"")+".");
    if(M.fretePctTicket>=0.18)
      add("frete",46,"warn","gauge","Frete equivale a "+PCT0(M.fretePctTicket)+" do ticket","região cara de atender para o valor que compra.");
  }

  /* ── 9. PRODUTO E AFINIDADE ── */
  if(M.its.length){
    if(M.concentracaoCat>=0.75 && M.categorias.length>=1)
      add("produto",clamp(48+M.concentracaoCat*36,0,84),"acc","box","Cliente especialista em "+M.catTop.k,
        PCT0(M.concentracaoCat)+" de tudo que comprou é dessa categoria.");
    else if(M.categorias.length>=4)
      add("produto",52,"pos","layers","Cliente explorador: "+NUM(M.categorias.length)+" categorias diferentes",
        NUM(M.produtos.length)+" produtos distintos — receptivo a novidade.");
    if(M.concentracaoProd>=0.5 && M.prodTop)
      add("produto",56,"acc","star","Metade das compras em um só produto",
        M.prodTop.nome+" responde por "+PCT0(M.concentracaoProd)+" das unidades.");
    if(M.recompraSku>=1)
      add("produto",50,"pos","repeat","Recomprou "+NUM(M.recompraSku)+" produto"+(M.recompraSku>1?"s":"")+" repetido"+(M.recompraSku>1?"s":""),
        "sinal forte de satisfação com o item — vale oferecer variação dele.");
    if(M.catNaoExplorada)
      add("produto",46,"acc","bulb","Nunca comprou "+M.catNaoExplorada.c,
        "categoria popular na loja ("+NUM(M.catNaoExplorada.n)+" unidades vendidas) e ausente no histórico dele — cross-sell natural.");
    if(M.nuncaComprou&&M.nuncaComprou.length&&M.n>=2)
      add("produto",34,"acc","eye","Produto campeão da loja que ele nunca levou",
        String(M.nuncaComprou[0].t||"")+" está entre os mais vendidos e não aparece no histórico.");
    /* só chama de "preferência" o que passa no teste; caso contrário, ou cala
       ou diz explicitamente que não dá para concluir */
    var pCor=preferencia(M.cores,M.unidades);
    if(!pCor.vazio && pCor.conclusivo)
      add("produto",clamp(30+pCor.w.p*30,0,62),"acc","palette","Preferência por "+pCor.top.k+" se sustenta",
        NUM(pCor.top.n)+" de "+NUM(pCor.w.n)+" unidades ("+PCT0(pCor.w.p)+", IC95 "+ciTxt(pCor.w)+"), acima dos "+PCT0(pCor.acaso)+" esperados por acaso entre "+pCor.opcoes+" estampas.");
    else if(!pCor.vazio && pCor.empate && M.unidades>=2)
      add("produto",26,"warn","info","Sem estampa favorita",
        "empate em "+NUM(pCor.top.n)+" unidade"+(pCor.top.n>1?"s":"")+" entre "+pCor.top.k+" e "+pCor.seg.k+" — não há tendência, há amostra pequena.");
  }

  /* ── 10. TAMANHO E CAIMENTO ── */
  if(M.tamTop){
    var pTam=preferencia(M.tamanhos,M.unidades);
    if(pTam.conclusivo && M.concentracaoTam>=0.7)
      add("tamanho",54,"pos","ruler","Tamanho "+pTam.top.k+" em "+PCT0(pTam.w.p)+" das compras",
        NUM(pTam.top.n)+" de "+NUM(pTam.w.n)+" unidades (IC95 "+ciTxt(pTam.w)+") — grade previsível o bastante para priorizar estoque.");
    else if(!pTam.vazio && !pTam.conclusivo && M.unidades>=2)
      add("tamanho",24,"warn","info","Tamanho ainda não conclusivo",
        NUM(pTam.top.n)+" de "+NUM(pTam.w.n)+" em "+pTam.top.k+" (IC95 "+ciTxt(pTam.w)+") — intervalo largo demais para tratar como grade fixa.");
    else if(M.tamanhosDistintos>=3)
      add("tamanho",50,"warn","ruler","Compra em "+NUM(M.tamanhosDistintos)+" tamanhos diferentes",
        "inconsistência de grade costuma anteceder troca — vale revisar a tabela de medidas.");
    if(M.tamPorCat.length>=2){
      var variam=M.tamPorCat.map(function(x){ return x.tam; });
      var unicos={}; variam.forEach(function(t){ unicos[t]=1; });
      if(Object.keys(unicos).length>1)
        add("tamanho",44,"acc","ruler","Tamanho varia por categoria",
          M.tamPorCat.slice(0,3).map(function(x){ return x.cat+" "+x.tam; }).join(" · ")+" — perfil de caimento diferente por peça.");
    }
    if(M.tamDevTop)
      add("tamanho",clamp(56+M.tamDevTopN*6,0,84),"neg","alert","Devoluções concentradas no tamanho "+M.tamDevTop,
        M.tamDevTopN+" registro"+(M.tamDevTopN>1?"s":"")+" — provável desalinhamento entre a grade e o corpo dele.");
    if(M.problemaTamanho)
      add("tamanho",70,"neg","ruler","Motivo de devolução é tamanho","o problema não é o produto, é a grade — orientação de medidas resolveria.");
  }

  /* ── 11. SEQUÊNCIA DE COMPRA ── */
  if(M.seqCat.length>=2){
    add("seq",36,"acc","arrow","Jornada: "+M.seqCat.slice(-4).join(" → "),"a ordem das categorias comprada até aqui.");
    /* só afirma sequência quando a taxa condicional se separa da taxa normal
       da loja — caso contrário é popularidade de catálogo disfarçada de padrão */
    if(M.proximaCat && M.proximaCat.signif)
      add("seq",clamp(48+M.proximaCat.lift*30,0,84),"acc","target",
        "Próxima provável: "+M.proximaCat.cat+" ("+PCT0(M.proximaCat.p)+")",
        "depois de "+M.proximaCat.de+" a taxa sobe para "+PCT0(M.proximaCat.p)+" [IC95 "+PCT0(M.proximaCat.lo)+"–"+PCT0(M.proximaCat.hi)+"], contra "+PCT0(M.proximaCat.p0)+" do fluxo normal da loja, em "+NUM(M.proximaCat.n)+" transições.");
    else if(M.proximaCat)
      add("seq",30,"warn","info","Sem padrão de sequência detectável",
        "o destino mais frequente após "+M.proximaCat.de+" ("+M.proximaCat.cat+", "+PCT0(M.proximaCat.p)+") não se separa da taxa normal da loja ("+PCT0(M.proximaCat.p0)+").");
  }

  /* ── 12. PRIMEIRO PRODUTO ── */
  if(M.primeiroProduto){
    var cp=M.coorte&&M.coorte.produto;
    if(cp&&cp.n>=5){
      if(M.ltv>cp.ltv*1.3)
        add("entrada",64,"pos","star","Superou quem entra pelo mesmo produto",
          "clientes que começam por "+M.primeiroProduto+" fazem "+BRL(cp.ltv)+" de LTV médio; este está em "+BRL(M.ltv)+".");
      else if(M.ltv<cp.ltv*0.7)
        add("entrada",50,"warn","star","Abaixo de quem entra pelo mesmo produto",
          "a média de quem começa por "+M.primeiroProduto+" é "+BRL(cp.ltv)+"; este está em "+BRL(M.ltv)+".");
      if(cp.rec>=0.35)
        add("entrada",46,"acc","check",M.primeiroProduto+" é um bom produto de entrada",
          PCT0(cp.rec)+" de quem começa por ele volta a comprar — este cliente já fez "+NUM(M.n)+" pedidos.");
    } else {
      add("entrada",30,"acc","star","Produto de entrada: "+M.primeiroProduto,
        "foi o item que trouxe este cliente para a base"+(M.canalPrimeiro?", via "+M.canalPrimeiro:"")+".");
    }
  }

  /* ── 13. CARRINHO E COMPOSIÇÃO ── */
  if(M.n>=2){
    if(sa.itens_pedido && M.itensPed>sa.itens_pedido*1.4)
      add("carrinho",48,"pos","cart",M.itensPed.toFixed(1)+" itens por pedido vs "+Number(sa.itens_pedido).toFixed(1)+" da base",
        "monta carrinhos maiores que a média — bom alvo para combo.");
    else if(sa.itens_pedido && M.itensPed<sa.itens_pedido*0.7)
      add("carrinho",42,"warn","cart","Carrinhos pequenos: "+M.itensPed.toFixed(1)+" itens","quase sempre compra peça única — oportunidade de order bump.");
    if(M.categorias.length>=2 && M.n>=3)
      add("carrinho",32,"acc","layers","Mistura categorias no mesmo pedido","combos entre "+M.categorias.slice(0,2).map(function(x){return x.k;}).join(" e ")+" fazem sentido para ele.");
  }

  /* ── 14. AQUISIÇÃO E CANAL ── */
  if(M.canalTop && M.n>=2){
    if(M.canalTop.pct>=0.6)
      add("canal",clamp(34+M.canalTop.pct*45,0,74),"acc","route",PCT0(M.canalTop.pct)+" dos pedidos via "+M.canalTop.canal,
        "canal dominante deste cliente — priorize-o na comunicação.");
    if(M.mudouCanal && M.canalPrimeiro!=="Direto" && M.canalUltimo==="Direto")
      add("canal",70,"pos","shield","Adquirido via "+M.canalPrimeiro+", hoje compra direto",
        PCT0(M.diretoAgora)+" dos pedidos recentes são diretos — não depende mais de mídia paga.");
    else if(M.canalPrimeiro!=="Direto" && M.diretoAgora<0.25 && M.n>=3)
      add("canal",52,"warn","route","Ainda dependente de "+M.canalPrimeiro,
        "quase todos os pedidos continuam vindo de mídia — custo de recompra segue alto.");
    if(M.jornada.length>=3)
      add("canal",40,"acc","arrow","Jornada multicanal: "+M.jornada.join(" → "),"passou por "+NUM(M.jornada.length)+" canais diferentes ao longo do relacionamento.");
  }
  if(M.campanhaPrimeira)
    add("canal",30,"acc","bolt","Campanha de aquisição: "+M.campanhaPrimeira,
      "foi essa campanha que trouxe um cliente de "+BRL(M.ltv)+" de LTV.");

  /* ── 15. DROPS ── */
  if(M.colecoes.length){
    if(M.colecoes.length>=3)
      add("drop",56,"pos","layers","Participou de "+NUM(M.colecoes.length)+" drops diferentes",
        "cliente de lançamento — avise antes, ele compra.");
    if(M.dropTop)
      add("drop",38,"acc","layers","Drop favorito: "+M.dropTop.k,
        NUM(M.dropTop.n)+" unidades e "+BRL(M.dropTop.rec)+" de receita só nesse drop.");
  }

  /* ── 16. TEMPO ── */
  /* Horário e dia são onde o ruído mais engana: 24 horas e 7 dias como
     categorias contra um punhado de pedidos produzem "padrões" que somem na
     compra seguinte. Só afirmamos com intervalo acima do acaso. */
  if(M.n>=4){
    var faixasLista=[["Madrugada",0,5],["Manhã",6,11],["Tarde",12,17],["Noite",18,23]]
      .map(function(f){ var s=0; for(var h=f[1];h<=f[2];h++) s+=M.hr[h]; return {k:f[0],n:s}; })
      .filter(function(x){ return x.n>0; }).sort(function(a,b){ return b.n-a.n; });
    var pFx=preferencia(faixasLista,M.n);
    if(pFx.conclusivo)
      add("tempo",clamp(34+pFx.w.p*34,0,68),"acc","clock",
        PCT0(pFx.w.p)+" dos pedidos no período da "+pFx.top.k.toLowerCase(),
        NUM(pFx.top.n)+" de "+NUM(M.n)+" pedidos (IC95 "+ciTxt(pFx.w)+"), acima dos 25% de uma distribuição uniforme — janela defensável para disparo.");

    /* fim de semana: 2 dias contra 5, então a comparação é por dia, e testada
       contra a proporção esperada de 2/7 */
    var pFds=vsBase(M.fimDeSemana,M.n,2/7);
    if(pFds.acima)
      add("tempo",42,"acc","calendar","Concentra em fins de semana",
        NUM(M.fimDeSemana)+" de "+NUM(M.n)+" pedidos ("+PCT0(pFds.w.p)+", IC95 "+ciTxt(pFds.w)+") contra os "+PCT0(2/7)+" esperados se comprasse em qualquer dia.");
    else if(pFds.abaixo)
      add("tempo",38,"acc","calendar","Concentra em dias úteis",
        PCT0(1-pFds.w.p)+" dos pedidos de segunda a sexta (IC95 do fim de semana: "+ciTxt(pFds.w)+", abaixo dos "+PCT0(2/7)+" esperados).");
  }

  /* ── 17. GEOGRAFIA ── */
  if(M.cidadeStats && M.cidadeStats.n>=8 && M.cidadeStats.rank/M.cidadeStats.n<=0.05)
    add("geo",64,"acc","pin","Top "+Math.max(1,Math.round(M.cidadeStats.rank/M.cidadeStats.n*100))+"% dos clientes de "+String(M.c.cidade||""),
      "#"+M.cidadeStats.rank+" entre "+NUM(M.cidadeStats.n)+" clientes da cidade.");
  if(M.regiaoStats && M.regiaoStats.n>=10){
    var rr=multi(M.ticket,M.regiaoStats.ticket);
    if(rr>=1.3) add("geo",44,"pos","pin","Ticket "+rr.toFixed(1)+"× a média do "+regiaoOf(M.c.estado),
      BRL(M.ticket)+" contra "+BRL(M.regiaoStats.ticket)+" dos clientes da mesma região.");
  }
  if(M.c.cidade) add("geo",26,"acc","pin","Base em "+String(M.c.cidade)+(M.c.estado?"/"+ufOf(M.c.estado):""),
    "considere custo de frete e prazo de entrega ao desenhar a oferta.");

  /* ── 18. DEVOLUÇÕES ── */
  if(M.devTotal){
    add("devol",clamp(50+M.taxaDev*90,0,86),M.taxaDev>0.25?"neg":"warn","swap",
      NUM(M.devTotal)+" devoluções/trocas em "+NUM(M.n)+" pedidos ("+PCT0(M.taxaDev)+")",
      BRL(M.valorDevolvido)+" devolvidos e "+BRL(M.custoDevLog)+" de custo logístico.");
    if(M.motivoTop)
      add("devol",46,"warn","alert","Motivo predominante: "+M.motivoTop,
        M.motivoTopN+" de "+NUM(M.devTotal)+" registros — atacar essa causa reduz o custo deste cliente.");
    if(M.lucroLiquido<M.lucro*0.7 && M.lucro>0)
      add("devol",66,"neg","chart","Lucro real "+PCT0(1-M.lucroLiquido/M.lucro)+" menor após devoluções",
        BRL(M.lucro)+" de lucro bruto viram "+BRL(M.lucroLiquido)+" depois do custo de trocas.");
  }

  /* ── 19. COORTE ── */
  var co=M.coorte||{};
  if(co.mes && co.mes.n>=5){
    var dl=multi(M.ltv,co.mes.ltv);
    if(dl>=1.4) add("coorte",62,"pos","compare","LTV "+Math.round((dl-1)*100)+"% acima da coorte de "+co.mesKey,
      "quem entrou no mesmo mês faz "+BRL(co.mes.ltv)+" em média; este cliente está em "+BRL(M.ltv)+".");
    else if(dl>0 && dl<=0.65) add("coorte",50,"warn","compare","Abaixo do esperado para a coorte de "+co.mesKey,
      "a média de quem entrou junto é "+BRL(co.mes.ltv)+"; este está em "+BRL(M.ltv)+".");
    if(co.mes.rec!=null && M.n>1 && co.mes.rec<0.4)
      add("coorte",44,"pos","check","Recomprou numa coorte de baixa retenção",
        "só "+PCT0(co.mes.rec)+" dos que entraram em "+co.mesKey+" voltaram — este fez "+NUM(M.n)+" pedidos.");
  }
  if(co.canal && co.canal.n>=8){
    var dc2=multi(M.ltv,co.canal.ltv);
    if(dc2>=1.4) add("coorte",54,"pos","route","LTV acima da média de quem vem de "+String(M.c.origem_primeira||""),
      BRL(M.ltv)+" contra "+BRL(co.canal.ltv)+" do canal que o adquiriu.");
  }
  if(co.regiao && co.regiao.n>=10 && M.ltv>co.regiao.ltv*1.3)
    add("coorte",42,"pos","pin","LTV acima da média do "+regiaoOf(M.c.estado),
      BRL(M.ltv)+" contra "+BRL(co.regiao.ltv)+" da região.");

  /* ── 20. ANOMALIAS ── */
  if(M.n>=3){
    if(M.maiorPedido && M.ticket>0 && nz(M.maiorPedido.faturamento)>M.ticket*3)
      add("anomalia",58,"warn","alert","Pedido muito fora do padrão",
        BRL(nz(M.maiorPedido.faturamento))+" em "+DATE(M.maiorPedido.created_at)+", contra ticket médio de "+BRL(M.ticket)+".");
    if(M.menorPedido && M.ticket>0 && nz(M.menorPedido.faturamento)<M.ticket*0.3)
      add("anomalia",36,"acc","alert","Pedido muito abaixo do padrão",
        BRL(nz(M.menorPedido.faturamento))+" em "+DATE(M.menorPedido.created_at)+" — possível teste ou item avulso.");
    if(M.reativacoes>=1 && M.ticketUltimo>M.ticket*1.5)
      add("anomalia",64,"pos","flame","Voltou depois de sumir e comprou grande",
        "último pedido de "+BRL(M.ticketUltimo)+" contra ticket médio de "+BRL(M.ticket)+".");
    if(M.gapMax>0 && M.ciclo>0 && M.gapMax>M.ciclo*4)
      add("anomalia",40,"warn","clock","Já ficou "+DIAS(M.gapMax)+" parado","e voltou — o histórico mostra que reativação funciona com ele.");
  }
  if(M.nCancelados>=2)
    add("anomalia",52,"warn","alert",NUM(M.nCancelados)+" pedidos cancelados ou devolvidos","volume anormal de pedidos que não se concretizaram.");

  /* ── 21. POTENCIAL NÃO CAPTURADO ── */
  if(temBase && M.gapLtv>0 && M.ltvEsperado>0 && M.gapLtv/M.ltvEsperado>=0.2)
    add("potencial",clamp(46+(M.gapLtv/M.ltvEsperado)*45,0,82),"acc","target",
      "Potencial de expansão de "+BRL(M.gapLtv),
      "clientes com perfil semelhante fazem "+BRL(M.ltvEsperado)+" de LTV; este está em "+BRL(M.ltv)+".");
  if(M.catNaoExplorada && M.n>=2)
    add("potencial",42,"acc","bulb","Categoria inexplorada: "+M.catNaoExplorada.c,"nunca comprou, e é das mais vendidas da loja.");
  if(temBase && M.ticket<M.avg.ticket && M.n>M.avg.pedidos)
    add("potencial",48,"acc","compare","Compra muito, gasta pouco por vez",
      NUM(M.n)+" pedidos (acima da média) com ticket de "+BRL(M.ticket)+" (abaixo dos "+BRL(M.avg.ticket)+" médios) — upsell é o caminho.");
  if(M.pctComDesconto<0.3 && M.n>=3 && M.ticket>0)
    add("potencial",40,"pos","money","Aceita preço cheio: teste um ticket maior","não precisa de cupom — ofereça a peça mais cara da categoria favorita.");

  C.sort(function(a,b){ return b.score-a.score; });
  return C;
}

function aiPanel(M){
  var C=construirInsights(M);
  function item(x){
    return '<div class="cid-aid-item"><span class="cid-aid-ico '+x.tone+'">'+ic(x.ico)+'</span>'
      +'<span class="cid-aid-txt"><b>'+esc(x.lead)+'</b>: '+esc(x.rest)+'</span></div>';
  }
  var body;
  if(!C.length){
    body='<div class="cid-aid-empty">Nada salta aos olhos por enquanto — este cliente está dentro da média da base em todas as dimensões analisadas. '
      +'Com mais pedidos no histórico, o motor passa a ter o que comparar.</div>';
  } else {
    function secao(k,lbl,icon,itens,aberta){
      if(!itens.length) return "";
      return '<div class="cid-aid-sec'+(k==="destaque"?" destaque":"")+(aberta?" is-open":"")+'" data-sec="'+k+'">'
        +'<button class="cid-aid-sechd" type="button">'
        +'<span class="sec-l">'+ic(icon)+esc(lbl)+'</span>'
        +'<span class="sec-l"><span class="sec-n">'+itens.length+'</span>'
        +'<span class="sec-caret">'+ic("down")+'</span></span></button>'
        +'<div class="cid-aid-secbody">'+itens.map(item).join("")+'</div></div>';
    }
    var destaques=C.slice(0,5);
    body=secao("destaque","Destaques","bolt",destaques,true);
    FAMILIAS.forEach(function(f){
      var itens=C.filter(function(x){ return x.cat===f.k; });
      body+=secao(f.k,f.lbl,f.ico,itens,false);
    });
  }
  var n=C.length;
  var fab='<button id="cid-ai-fab" type="button"><span class="cid-fab-dot"></span>Insights'+(n?' · '+n:'')+'</button>';
  var drawer='<div id="cid-ai-drawer">'
    +'<div class="cid-aid-head"><h3>'+ic("bulb")+'Insights</h3>'
    +'<button class="cid-aid-close" type="button" aria-label="Fechar"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>'
    +'<div class="cid-aid-body">'+body+'</div></div>';
  return fab+drawer;
}

function wireAiDrawer(wrap){
  var fab=wrap.querySelector("#cid-ai-fab"), drawer=wrap.querySelector("#cid-ai-drawer");
  if(!fab||!drawer) return;
  setTimeout(function(){ fab.classList.add("is-visible"); },220);
  function cascata(escopo){
    Array.prototype.forEach.call(escopo.querySelectorAll(".cid-aid-item"),function(el,i){
      el.style.transitionDelay=(90+i*70)+"ms";
    });
  }
  function abrir(){
    drawer.classList.add("open");
    var aberta=drawer.querySelector(".cid-aid-sec.is-open");
    cascata(aberta||drawer);
  }
  function fechar(){
    drawer.classList.remove("open");
    Array.prototype.forEach.call(drawer.querySelectorAll(".cid-aid-item"),function(el){ el.style.transitionDelay="0ms"; });
  }
  fab.addEventListener("click",function(e){ e.stopPropagation(); drawer.classList.contains("open")?fechar():abrir(); });
  drawer.querySelector(".cid-aid-close").addEventListener("click",fechar);
  /* seções colapsáveis: a que abre recebe a cascata dos próprios itens */
  drawer.addEventListener("click",function(e){
    var hd=e.target.closest(".cid-aid-sechd"); if(!hd) return;
    var sec=hd.parentNode, vai=!sec.classList.contains("is-open");
    sec.classList.toggle("is-open",vai);
    if(vai) cascata(sec);
  });
  /* fecha ao clicar fora — vincula ao documento uma única vez, pois o
     render substitui os nós a cada atualização de dados */
  if(!window._cidAiDocBound){
    window._cidAiDocBound=true;
    document.addEventListener("click",function(e){
      var dr=document.getElementById("cid-ai-drawer"), fb=document.getElementById("cid-ai-fab");
      if(dr&&dr.classList.contains("open") && !dr.contains(e.target) && (!fb||!fb.contains(e.target))) dr.classList.remove("open");
    });
  }
}
})();
